<style lang="stylus">
    .tool-wrap
        width 100%
        position relative
    .special-tool
        background var(--bg-color-white)
        position absolute
        width 100%
        border 1px solid $box-bordercolor
        border-top unset
        border-left-style: none;
        border-right-style: none;
        box-sizing border-box
        height 45px
        cursor default
        overflow auto
        color #444
        font-size 12px
        display flex
        z-index -2
        .optionbox-line
            padding 10px 0
            height 44px
            white-space nowrap
            display flex
            align-items center
            >div
                white-space nowrap
                display flex
                align-items center
            p
                display inline-block
                padding-left 15px
                line-height 24px
                text-align right
            .iview_input
                display inline-block
                width 69px
                height 24px
                margin-left 20px
                .ivu-input-number-input-wrap
                    height 24px
                .ivu-input-number-handler
                    height 12px
                input
                    display block
                    height 24px
                    line-height 24px

            .optionbox-btn
                height 24px
                margin-left 15px
                cursor pointer
                &:hover
                    background-color $main-hovercolor
                .item-icon
                    width 23px
                    height 23px
                    float left
                    margin-left 5px
            .optionbox-color
                display inline-block
                width 24px
                height 24px
                margin-left 15px
                border-radius 5px
                border 1px solid #c4c4c4
                cursor pointer

            .optionbox-showbox
                position relative
                width 90px
                height 24px
                border 1px solid #E0E0E0
                margin-left 20px
                background-color var(--bg-color-white)
                border-radius 2px
                transition border-color .2s ease-in-out
                &:hover
                    border-color var(--themeHover)
                    cursor pointer
                .item-arrow
                    position absolute
                    top 50%
                    right 5px
                    transform translate(0, -50%)
                    width 8px
                    height 4px
                    cursor pointer
                    color: var(--svg-color-primary)
                .blockItem-list
                    position fixed
                    width max-content
                    margin-top 126px
                    padding 6px 0
                    background-color $navigation-modal-bgcolor
                    border-radius 5px
                    box-shadow $common-box-shadow
                    color $navigation-modal-fontcolor
                    font-size $navigation-modal-fontsize
                    li
                        position relative
                        list-style none
                        padding 3px 30px 3px 20px
                        height 30px
                        width 100%
                        &:hover,&.active-li
                            background-color $main-hovercolor
    .navigation-tab
        position relative
        width 100%
        height 40px
        min-width 654px
        border 1px solid $box-bordercolor
        border-top unset
        border-left-style: none;
        box-sizing border-box
        background-color var(--bg-color-primary)
        &.navigation-tab-showLibrary
            min-width 681px
        .library-search-btn
            position relative
            float left
            padding 0 10px
            height 100%
            display flex
            align-items center
            width 48px
            &::after{
              position: absolute;
              right: 0
              content:"";
              display: block;
              width: 1px
              height: 20px
              background-color: $box-bordercolor;
            }
            svg:focus
                outline none
            .item-search
                padding 4px
                width 32px
                height 32px
                cursor pointer
                top 50%;
                left 50%;
                transform translate(-50%, -50%) rotate(180deg);
                position absolute
                border-radius: $box-radius;
                svg
                    fill var(--svg-color-gray-42)
                &:hover
                    background $main-hovercolor
        .tab-block-box
            float left
            margin-right 4px
            height 100%
            display flex
            align-items center
            .tab-block-arrowItem
                float left
                position relative
                width 35px
                height 22px
                margin-right 10px
                .item-icon
                    width 20px
                    height 20px
                .item-arrow
                    position absolute
                    left 0
                    top -2px
                    width 24px
                    height 20px
                .item-icon:not(.navigation-active-btn):hover
                    background-color $main-hovercolor
                    cursor pointer
                .arrowItem-click-mask
                    position absolute
                    width 10px
                    height 100%
                    left 22px
                    top 0
                    z-index 1
                    .item-arrow
                        position absolute
                        left 0
                        top 0
                        width 10px
                        height 22px
                        &:hover
                            background-color $main-hovercolor
                            cursor pointer
                .arrowItem-list
                    margin-top 6px
                    background-color $navigation-modal-bgcolor
                    border-radius 5px
                    box-shadow $box-shadow
                    box-sizing border-box
                    .arrowItem-li
                        padding 5px 0
                        list-style none
                        width 100%
                        height 32px
                        box-sizing border-box
                        user-select none
                        cursor pointer
                        &:hover
                            background-color $main-hovercolor
                        .item-icon
                            float left
                            margin-right 8px
                            margin-left 12px
                            width 20px
                            height 20px
                        p
                            float left
                            line-height 22px

            .expand-tab-item
                overflow hidden
                width 40px !important
                .expand-tab-item-left{
                    position relative
                  width: calc(100% - 8px);
                  height: 100%;
                  display: inline-block;
                }
                .expand-tab-item-right{
                  width: 8px;
                  height: 100%;
                  display: inline-block;
                }
                .expand-tab-item-left:hover,.expand-tab-item-right:hover{
                  background-color: inherit;
                }
            .activeFunc
                background-color var(--themeActived)

            .linebox-selectbox
                display inline-block
                vertical-align middle
                position relative
                margin 0 8px

                &.rightArrowTool
                    .showbox .item-icon
                        left 6px
                &.leftArrowTool, &.rightArrowTool
                    .showbox
                        border-radius 4px;
                .icon-tiny-down
                    position absolute
                    transform translateY(-50%)
                    top 50%
                    right 3px
                    width 6px
                    height 4px
                .icon-tiny-arrow
                    position absolute
                    transform translateY(-50%)
                    top 50%
                    right 3px
                    width 8px
                    height 4.25px
                    color: var(--svg-color-primary);
                .rotate
                    transform rotate(180deg)
                .disabled-box
                    cursor no-drop !important
                    svg
                        opacity 0.2
                        filter grayscale(1)
                    span
                        color #e0e0e0 !important
                .showbox
                    position relative
                    width 50px
                    height 24px
                    display: flex;
                    align-items: center
                    background-color var(--bg-color-white)
                    border-radius: $common-border-radius;
                    border: 1px solid var(--border-color-line-select-box);
                    &:hover
                        background-color: var(--bg-color-line-box-select-box-hover);

                    &:not(.disabled-box):hover
                        cursor pointer
                    .ivu-icon-ios-arrow-down
                        position absolute
                        right 5px
                        top 50%
                        transform translateY(-50%)
                    .item-icon
                        position: absolute;
                        width: 29px;
                        height: 40px
                        color var(--svg-color-primary)
                    .item-icon.rotate
                        transform rotate(180deg)


            .tab-block-item
                float left
                position relative
                width 32px
                height 32px
                margin-right 4px
                cursor pointer
                border-radius $common-border-radius
                &.with-arrow
                    width 36px;
                    margin-right 12px;
                    &.expand-tab-item
                        margin-right 8px;
                        .item-icon-center
                            left: 50%;
                            transform translate(-50%,-50%)
                        &.lock-all
                            width 32px!important;
                            .expand-tab-item-left
                                width: 100%;
                                &::hover
                                    background-color: transparent;
                    &:first-child
                        // margin-left 4px;
                    &:nth-child(2)
                        margin-right 8px;
                    .item-icon-center
                        left: 45%;
                &:not(.activeFunc):not(.navigation-active-btn):not(.navigation-ban-btn):hover
                    background-color #eee
                .item-ban-btn
                    cursor not-allowed
                    opacity 0.4
                .item-icon-center
                    pointer-events none
                    position absolute
                    top 50%
                    left 50%
                    transform translate(-50%,-50%)
                    width 24px
                    height 24px
                    color: var(--svg-color-primary);
                .item-icon
                    width 24px
                    height 24px
                .item-arrow
                    position absolute
                    top: 50%;
                    right: 0px;
                    transform translate(0, -50%)
                    width 8px
                    height 4.25px;
                    color: var(--svg-color-primary)
                .item-color
                    pointer-events none
                    position absolute
                    margin-left 7px
                    bottom 5px
                    border-radius 1.5px
                    width 16px
                    height 3px
            .tab-block-item.navigation-ban-btn
                cursor not-allowed
            .tab-block-item:not(.navigation-ban-btn,.navigation-active-btn):hover
                background-color $main-hovercolor
            .append-box
                position fixed
                right 130px
                top 100px
                width max-content
                height 52px
                padding 10px
                background-color $navigation-modal-bgcolor
                border-radius 5px
                box-shadow $box-shadow
                .tab-block-item
                    &.with-arrow
                        margin-left 4px;
                        margin-right 8px;
                .linebox-selectbox
                    margin-top 4px
                    width auto;
        .moretool-btn
            margin-right 0
            .more-tool-icon
                color: var(--svg-color-primary)
        .tab-append-box
            position absolute
            display block
            width 32px
            height 32px
            left -30px
            top 0
            .item-icon
                width 20px
                height 20px
                &:not(.ban-btn):hover
                    cursor pointer
            .blockItem-list
                position absolute
                width max-content
                margin-top 6px
                background-color $navigation-modal-bgcolor
                border-radius 8px
                box-shadow $common-box-shadow
                box-sizing border-box
                &.padding-list
                    padding: 6px
                &.line-size-list, &.line-type-list
                    &::-webkit-scrollbar-track
                        background transparent
                    &::-webkit-scrollbar
                        background transparent
                    width 216px
                    max-height 400px
                    overflow-y overlay
                    .arrowItem-li span
                        margin-right 16px
                &.line-size-list
                    .arrowItem-li
                        .lineheight-preview
                            width 114px
                            margin-right 8px
                            margin-left 16px
                            background var(--bg-color-black)
                    .splice-line
                        width 80%
                        height 1px
                        margin 4px auto
                        background var(--border-color-box-6)

                    .expand-item-jump
                        position relative
                        display flex
                        padding-left 36px
                        svg
                            position absolute
                            left 10px
                            top 2px
                            width 24px
                            height 24px
                            color: var(--svg-color-gray-42-secondary)
                            &:focus
                                outline: none
                &.line-type-list
                    .arrowItem-li .item-icon
                        width 160px
                        height 18px;
                        margin-left 16px
                &.line-anime-list
                    padding 16px;
                    min-width 216px;
                    min-height 426px
                    .switch-set
                        padding-bottom 16px;
                        border-bottom 1px solid var(--border-color-box-8)
                        margin-bottom 16px;
                        .switch-title
                            display flex;
                            justify-content space-between;
                            align-items center
                            margin-bottom 16px;
                            > span
                                display flex;
                                align-items center
                                .line-animate-tip
                                    height 16px;
                                    line-height 16px;
                                    margin-left 8px;


                                .vip-icon
                                    cursor pointer
                                    margin-top 2px;
                            .title
                                height 16px;
                                line-height 16px;
                                font-weight bold;
                                color var(--text-color-primary)
                        .switch-default
                            .switch-box
                                white-space nowrap
                                .ivu-checkbox
                                    margin-right 4px
                                    &:not(.ivu-checkbox-checked)
                                        .ivu-checkbox-inner
                                            background-color var(--bg-color-tertiary)
                    .property-set
                        padding-bottom 16px;
                        border-bottom 1px solid var(--border-color-box-8)
                        margin-bottom 16px;
                        .style-title
                            font-weight bold;
                            color var(--text-color-primary)
                            margin-bottom 12px
                        .style-set-box
                            display flex
                            justify-content space-between
                            align-items center
                            margin-bottom 12px;
                            &:last-child
                                margin-bottom 0;
                            .left
                                color var(--text-color-primary);
                                font-weight 400;
                                white-space nowrap
                            .selecter
                                width 80px
                                border-radius 6px;
                            .color-set
                                width 80px
                                border-radius 6px;
                                border 1px solid var(--border-color-box-8);
                                padding 2px;
                                height 24px;
                                .color-preview
                                    width 100%;
                                    height 100%;
                                    border-radius: 2px;
                                    border: 1px solid var(--color-black-8) !important;
                                    background-clip: border-box !important

                    .show-set
                        .show-title
                            font-weight bold;
                            color var(--text-color-primary)
                            margin-bottom 16px
                        .ivu-radio-group
                            height 44px;
                        .label-box-radio .ivu-radio-wrapper
                            height 16px;
                            line-height 16px;
                            display: block;
                            .ivu-radio
                                margin-right 4px
                            &:first-child
                                margin-bottom 12px
                &.mirror-list
                    .arrowItem-li
                        padding 4px 26px 4px 16px;
                        .item-icon
                            float none
                            margin 0;
                        span
                            margin-right 0;
                            margin-left 6px;
                &.linebox-selector
                    display block
                    position absolute
                    left 0
                    top 35px
                    padding: 16px 0 10px 16px;
                    background-color var(--bg-color-tertiary)
                    height 360px
                    width 216px !important;
                    z-index 1
                    overflow hidden
                    border none;
                    border-radius 8px;
                    box-shadow: var(--box-shadow-color-box)
                    &.line-begin
                        .line-type-wrapper .line-type-content .item-down .arrowtype
                            left 0;
                    .line-title
                        line-height 16px;
                        margin-bottom 12px;
                        text-indent 0;
                    .line-size
                        padding-right 16px;
                        .ivu-slider
                            .ivu-slider-wrap
                                margin-left: auto;
                                width :100%;
                                .ivu-slider-stop
                                    // background-color: #424242;
                    .line
                        margin 16px 16px 16px 0;
                        border-top: 1px solid var(--border-color-box-8);
                    .line-type-wrapper
                        height calc(100% - 74px)
                        overflow-y auto;
                        display block;
                        padding-right 16px;
                        .line-type-content
                            display: grid;
                            grid-template-columns: repeat(4, 1fr);
                            grid-gap: 8px;
                        .item-down
                            width 40px
                            height 40px;
                            border-radius 6px;
                            position relative
                            &:hover, &.active
                                background-color transparent;
                            &.active
                                .border
                                    border: 2px solid var(--themeColor)
                            &:hover
                                .border
                                    border-color: var(--themeColor)
                            .arrowtype
                                width: 34px;
                                height 40px;
                                position absolute
                                top 0;
                                left 5px;
                                color var(--svg-color-gray-42)
                                &.rotate
                                    transform rotate(180deg)
                            .border
                                width: 40px;
                                height 40px;
                                position absolute
                                top 0;
                                left 0;
                                border-radius 6px;
                                border: 1px solid var(--border-color-box-8)
                .arrowItem-li
                    padding 5px 0
                    list-style none
                    width 100%
                    height 32px
                    box-sizing border-box
                    user-select none
                    cursor pointer
                    display flex
                    align-items center
                    // &:first-child
                    //     border-top-left-radius 5px;
                    //     border-top-right-radius 5px;
                    // &:last-child
                    //     border-bottom-left-radius 5px;
                    //     border-bottom-right-radius 5px;
                    border-radius 6px;
                    &:hover,&.active-li
                        background-color $main-hovercolor
                    .item-icon
                        float left
                        margin-right 8px
                        margin-left 12px
                        width 24px
                        height 24px
                        color var(--svg-color-primary)
                    p
                        margin-right auto
                        line-height 22px
                    span
                        margin-left 10px
                        margin-right 8px
            .blockItem-listbox
                height 180px
                padding 16px 20px
                background-color $navigation-modal-bgcolor
                border-bottom-left-radius 5px
                border-bottom-right-radius 5px
                color $navigation-modal-fontcolor
                font-size $navigation-modal-fontsize

                .blocks-container
                    display flex
                    justify-content space-between
                    align-items center
                    flex-wrap wrap
                .fix-ratio
                    position relative
                    margin-top 2px
                    width 24px !important
                    height 24px
                    border-radius 4px
                    svg
                        position absolute
                        top 50%
                        left 50%
                        width 18px
                        height 8px
                        transform translate(-50%,-50%)
                        color var(--svg-color-gray-42)
                    &:hover
                        background-color $common-hover-color
                        cursor pointer
                .actived-btn
                    background-color $common-select-color !important
                .block-input
                    margin-bottom 17px
                    width 110px
                    .blockinput
                        .ivu-input-number-handler-wrap, .ivu-input-number-input
                            background-color var(--bg-color-tertiary)
                    >svg
                        width 18px
                        height 8px
                    p
                        width 18px
                        text-align right
                        display inline-block
                        font-size 12px
                        margin 5px 0
                        margin-right 4px

                .blockItem-line
                    clear both
                    padding 5px 0
                    border-top 1px solid $box-bordercolor-lignt
                    &:last-child
                        margin-bottom 0
                        border-top unset
                    p
                        float left
                        width 50px
                        margin-right 10px
                        line-height 24px
                    .mirror-btn
                        float left
                        width 20px
                        height 20px
                        &:nth-child(2),&:nth-child(3)
                            margin-right 20px
                        svg
                            fill var(--svg-color-gray-75)
                            color var(--svg-color-gray-42)
                        .ban-btn
                            opacity: 0.2;
                            filter: grayscale(1);
                            cursor not-allowed;
                    .activeFunc
                        background-color var(--themeActived)
                    .item-icon.active
                        background-color $main-selectcolor
                    .rotateimg
                        position relative
                        float left
                        width 20px
                        height 20px
                        div
                            width 20px
                            height 20px
                            display flex
                            justify-content center
                            align-items center
                            >svg
                                width 20px
                                height 20px
                            >img
                                width 18px
                                height 18px
                        .rotate-mask
                            position absolute
                            top 0
                            left 0
                            z-index 1
                            cursor pointer
                            user-select none
                    .rotateinput
                        float left
                        margin-left 20px
                        width 81px
                        .ivu-input-number-handler-wrap, .ivu-input-number-input
                            background-color var(--bg-color-tertiary)
            .blockItem-alignbox
                position absolute
                width 180px
                padding 6px
                margin-top 6px
                background-color $navigation-modal-bgcolor
                border-radius 5px
                box-shadow $common-box-shadow
                color $navigation-modal-fontcolor
                font-size $navigation-modal-fontsize
                .blockItem-btnBox
                    display flex
                    align-items center
                    padding 3px 0
                    justify-content space-around
                    border-bottom 1px solid $box-bordercolor-lignt
                    flex-wrap wrap
                    &:last-child
                        border-bottom unset
                    .activeFunc
                        background-color var(--themeActived)
                    li
                        position relative
                        width 32px
                        height 32px
                        margin 0 4px
                        display block
                        flex-shrink 1
                        list-style none
                        text-align center
                        line-height 32px
                        border-radius $common-border-radius

                        &:not(.activeFunc):hover
                            background-color $main-hovercolor
                        &.navigation-ban-btn
                            pointer-events none
                            opacity .2
                        .item-icon
                            width 20px
                            height 20px
                            margin-top 6px
                            margin-bottom 6px
                            color: var(--svg-color-gray-42)
                            fill: var(--svg-color-gray-75)
                        &:nth-child(n+5)
                            margin-top 6px

                    li.active
                        background-color $main-selectcolor
            .blockItem-composebox
                position absolute
                margin-top 6px
                width max-content
                min-width 114px
                background-color $navigation-modal-bgcolor
                border-radius 8px
                box-shadow $common-box-shadow
                color $navigation-modal-fontcolor
                font-size $navigation-modal-fontsize
                padding: 6px  ;
                li
                    list-style none
                    padding 5px 0
                    height 32px
                    width 100%
                    position relative
                    border-radius 6px;
                    .item-icon
                        pointer-events none
                        float left
                        margin-left 16px;
                        margin-right 6px
                        width 24px
                        height 24px
                        color var(--svg-color-primary)
                    .vip-point
                        pointer-events none
                        width 20px
                        height 20px
                        display none

                    &.compose-box
                        display flex
                        align-items center
                        justify-content space-between
                        padding-right 16px
                        &.navigation-ban-btn
                            .compose-box-left , span
                                opacity .2
                                filter grayscale(1)
                        .compose-box-left
                            display flex
                            align-items center
                            margin-right 24px
                    &.autoformat-box
                        display flex
                        align-items center
                        justify-content space-between
                        padding-right 22px
                        .autoformat-left
                            display flex
                            align-items center
                            .autoFormat
                                color var(--svg-color-primary)
                            .replaceClr
                                color var(--svg-color-primary)
                                fill var(--svg-color-primary)
                    &:hover
                        .vip-point
                            display block
                    p
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 16px;
                    span
                        float right
                        line-height 22px

                    &:not(.navigation-ban-btn):hover
                        background-color $main-hovercolor
                li.navigation-ban-btn:hover
                    cursor not-allowed
            .blockItem-protectbox
                position absolute
                width max-content
                margin-top 6px
                padding 6px
                background-color $navigation-modal-bgcolor
                border-radius 8px
                box-shadow $common-box-shadow
                color $navigation-modal-fontcolor
                font-size $navigation-modal-fontsize
                .checked-menu-item::before
                    left 16px
                @media screen and (max-height: 768px)
                    height 350px
                    overflow-y scroll
                li
                    position relative
                    list-style none
                    padding 3px 30px 3px 38px
                    height 30px
                    width 100%
                    border-radius 6px;
                    p
                        float left
                        line-height 24px
                    &:hover
                        background-color $main-hovercolor
                    &.after-line
                        margin-bottom: 8px
                    &.after-line:after
                        content ''
                        position absolute
                        width calc(100% - 32px)
                        left 0
                        bottom -4px
                        margin-left 16px
                        height 1px
                        background var(--bg-color-top-lock-line)
                li.active:before
                    content '√'
                    position absolute
                    left 6px
                    top 6px
            .blockItem-themebox
                position absolute
                margin-top 6px
                width 340px
                padding 10px
                background-color $navigation-modal-bgcolor
                border-radius 5px
                box-shadow $common-box-shadow
                color $navigation-modal-fontcolor
                font-size $navigation-modal-fontsize
                user-select none
                display flex
                flex-wrap wrap
                li
                    position relative
                    float left
                    list-style none
                    padding 2px 4px
                    height 34px
                    width 42px
                    border-radius 2px
                    p
                        width 34px
                        height 30px
                        line-height 30px
                        text-align center
                        border-radius 3px
                    img
                        width 100%
                        height 100%
                    >div
                        width 34px
                        height 30px
                        line-height 30px
                        text-align center
                        border-radius 3px
                        background-color var(--bg-color-white)
                        padding 14px 3px
                    &:not(.active):hover
                        background-color $main-hovercolor
                .active
                    background-color $main-selectcolor
            .item-clickmask
                position absolute
                left 0
                top 0
                width 22px
                height 22px
                cursor pointer
                z-index 1
        .block-box-nomargin
            margin-right 0
        .tab-block-line
            float left
            height 24px
            width 1px
            background-color var(--bg-color-tab-block-line)
            margin-left 4px;
            margin-right 8px
            margin-top 8px
            &.ml-8
                margin-left 8px

    .layout-box
        width 330px
    .search-box
        width 330px
        .search-content
            overflow hidden
            padding 16px
            padding-top 0px
            border-bottom-left-radius 4px
            border-bottom-right-radius 4px
            background-color $navigation-modal-bgcolor
            .search-line
                height 58px
                margin-bottom 6px
                padding-left 2px
                .search-title
                    width auto
                    margin-right 14px
                    line-height 24px
                .ivu-input-wrapper
                    float left
                    width 180px
                    height 28px
                    line-height 28px
                    border-radius 3px
                .search-btn
                    position relative
                    float left
                    width 30px
                    height 30px
                    margin-left 10px
                    border-radius 3px
                    cursor pointer
                    &:hover
                        background-color $main-hovercolor
                    .item-icon
                        display block
                        width 20px
                        height 20px
                        margin 4px
                        color var(--svg-color-gray-42)
                .search-tool
                    float left
                    width 98px
                    height 24px
                    margin-left 10px
                    margin-top 3px
                    user-select none
                    div
                        position relative
                        float left
                        width 17px
                        height 17px
                        margin-top 3px
                        cursor pointer
                        .item-icon-center
                            width 17px
                            height 17px
                        &:first-child
                            margin-right 5px
                        &:hover
                            background-color $main-hovercolor
                    .tool-text
                        float right
                        width 44px
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        font-size 12px
                        line-height 2
                        text-indent 5px
            .search-checkbox
                overflow auto
                display: flex;
                flex-wrap wrap
                justify-content: space-between;
                li
                    height 20px
                    list-style none
                    margin-bottom 7px
                    cursor pointer
                    padding-left 2px
                    .ivu-checkbox
                        margin-right 10px
                        &:not(.ivu-checkbox-checked)
                            .ivu-checkbox-inner
                                background-color var(--bg-color-tertiary)
    .navigation-ban-btn
        cursor not-allowed
        .item-color
            opacity .2
            filter grayscale(1)
        .item-clickmask
            cursor not-allowed !important
        >.item-icon-center, .item-arrow
            opacity .2
            filter grayscale(1)
    .navigation-active-btn
        background-color $main-selectcolor
    .tabmodaltrans-enter-active,
    .tabmodaltrans-leave-active
        transition opacity .3s
    .tabmodaltrans-enter,
    .tabmodaltrans-leave-to
        opacity 0
</style>

<template>
    <div class="tool-wrap">
        <div class="navigation-tab global-background-color" :class="!showLibrary ? 'navigation-tab-showLibrary' : ''">
            <!-- <div class="library-search-btn" @click="toggleLib" v-if="!showLibrary">
                <iconSymbol :content="$t('tipsList.toggleLib')" v-tippy="{ placement: 'bottom-start' }" class="item-search" name="toggle" />
            </div> -->
            <div class="tab-block-box" style="margin-right: 4px">
                <div
                    class="tab-block-item"
                    style="margin-left: 8px"
                    :class="{
                        'navigation-ban-btn': !canUndo,
                        activeFunc: activeFunc == 'tabsUndo',
                    }"
                    :content="$t('tipsList.undo')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="undoOpe()"
                >
                    <iconSymbol class="item-icon-center" name="undo" />
                </div>
                <div
                    class="tab-block-item"
                    :class="{
                        'navigation-ban-btn': !canRedo,
                        activeFunc: activeFunc == 'tabsRedo',
                    }"
                    :content="$t('tipsList.redo')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="redoOpe()"
                >
                    <iconSymbol class="item-icon-center" name="redo" />
                </div>
                <redPoint :pointName="'styleBrush'" :create_time="1591401600000">
                    <div
                        class="tab-block-item"
                        :content="$t('tipsList.styleBrush')"
                        v-tippy="{ placement: 'bottom' }"
                        :class="{
                            'navigation-ban-btn': !isSelect,
                            'navigation-active-btn': isStyleBrush && isStyleBrushActive,
                        }"
                        @click="submitBoxItem('styleBrush')"
                    >
                        <iconSymbol class="item-icon-center" name="styleBrush" />
                    </div>
                </redPoint>
            </div>

            <div class="tab-block-box">
                <NavigationFont></NavigationFont>
            </div>
            <!-- 文本 链接线样式 -->
            <div class="tab-block-line" v-if="showToolList.includes('fontBtn') || showToolList.includes('connector')"></div>

            <div class="tab-block-box block-box-nomargin">
                <div
                    v-if="showToolList.includes('fontBtn')"
                    class="tab-block-item"
                    :class="{
                        'navigation-active-btn': isTextEditor,
                        activeFunc: activeFunc == 'tabsAddText',
                    }"
                    :content="$t('tipsList.text')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="submitBoxItem('tool', 'Text')"
                >
                    <iconSymbol class="item-icon-center" name="font1"></iconSymbol>
                </div>

                <div
                    v-if="showToolList.includes('connector')"
                    ref="connectorIcon"
                    class="tab-block-item expand-tab-item"
                    :class="{
                        'navigation-active-btn': isCreateConLine || isShowConnectorBox,
                        activeFunc: activeFunc == 'tabsConnectLine',
                    }"
                    :content="$t('tipsList.connector')"
                    v-tippy="{ placement: 'bottom' }"
                >
                    <span class="expand-tab-item-left" @click="submitBoxItem('connector', conType)">
                        <iconSymbol class="item-icon-center" :name="`linkline${2 - conType + 1}`"></iconSymbol>
                    </span>
                    <span class="expand-tab-item-right" @click="handleShowBox('connector', $event)">
                        <iconSymbol class="item-arrow" name="downArrow"></iconSymbol>
                    </span>
                </div>
            </div>
            <!-- 填充 线条 粗细 虚线 起始箭头-->
            <div class="tab-block-line ml-8" v-if="showToolList.includes('colorFill') || showToolList.includes('colorline')"></div>
            <div class="tab-block-box block-box-nomargin">
                <div
                    v-if="showToolList.includes('colorFill')"
                    class="tab-block-item"
                    :class="{
                        'navigation-active-btn': fillColorWindow,
                        'navigation-ban-btn': (!fillColorWindow && !isSelect) || isMMShape,
                        activeFunc: activeFunc == 'tabsFillColor',
                    }"
                    :content="$t('tipsList.fillColor')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="isSelect && !isMMShape && showFillColor($event)"
                >
                    <iconSymbol class="item-icon-center" :name="`fillcolor${isDarkTheme() ? '-dark' : ''}`" :style="`fill:${fillColor}`"></iconSymbol>
                    <!-- <div class="item-color" :style="{ backgroundColor: fillColor, border: fillColorBorder }"></div> -->
                </div>
                <div
                    v-if="showToolList.includes('colorline')"
                    class="tab-block-item"
                    :class="{
                        'navigation-active-btn': lineColorWindow,
                        'navigation-ban-btn': (!lineColorWindow && !isSelect) || isMMShape,
                        activeFunc: activeFunc == 'tabsLineCoor',
                    }"
                    :content="$t('tipsList.lineColor')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="isSelect && !isMMShape && showLineColor($event)"
                >
                    <iconSymbol class="item-icon-center" :name="`fillline${isDarkTheme() ? '-dark' : ''}`" :style="`fill:${lineColor}`"></iconSymbol>
                    <!-- <div class="item-color" :style="{ backgroundColor: lineColor, border: lineColorBorder }"></div> -->
                </div>
                <div
                    v-if="showToolList.includes('lineSize')"
                    class="tab-block-item"
                    ref="lineSizeIcon"
                    :content="$t('tipsList.lineSize')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="handleShowBox('lineSize', $event)"
                >
                    <iconSymbol class="item-icon-center" name="float-lineweight"></iconSymbol>
                </div>
                <div
                    v-if="showToolList.includes('lineType')"
                    class="tab-block-item"
                    ref="lineTypeIcon"
                    :content="$t('tipsList.lineType')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="handleShowBox('lineType', $event)"
                >
                    <iconSymbol class="item-icon-center" name="float-linestyle"></iconSymbol>
                </div>
                <div
                    v-if="showToolList.includes('lineAnime')"
                    class="tab-block-item"
                    ref="lineAnimeIcon"
                    :content="$t('lineanimate')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="handleShowBox('lineAnime', $event)"
                >
                    <iconSymbol class="item-icon-center" name="float-lineanimate"></iconSymbol>
                </div>

                <div v-if="showToolList.includes('leftArrow')" ref="leftArrowIcon" class="linebox-selectbox leftArrowTool">
                    <div
                        class="showbox"
                        :content="$t('tipsList.leftArrow')"
                        v-tippy="{ placement: 'bottom' }"
                        @click="handleShowBox('leftArrow', $event)"
                    >
                        <iconSymbol class="item-icon" :name="activeBeginTypeUrl()" />
                        <iconSymbol name="downArrow" class="icon-tiny-down icon-tiny-arrow" />
                    </div>
                </div>
                <div v-if="showToolList.includes('rightArrow')" ref="rightArrowIcon" class="linebox-selectbox rightArrowTool">
                    <div
                        class="showbox"
                        :content="$t('tipsList.rightArrow')"
                        v-tippy="{ placement: 'bottom' }"
                        @click="handleShowBox('rightArrow', $event)"
                    >
                        <iconSymbol class="item-icon rotate" :name="activeEndTypeUrl()" />
                        <iconSymbol name="downArrow" class="icon-tiny-down icon-tiny-arrow" />
                    </div>
                </div>
            </div>
            <!-- 翻转 组合 -->
            <div
                class="tab-block-line"
                v-if="showToolList.includes('layer') || showToolList.includes('mirror') || showToolList.includes('compose')"
            ></div>
            <div class="tab-block-box block-box-nomargin">
                <div
                    v-if="showToolList.includes('layer')"
                    ref="layerIcon"
                    class="tab-block-item with-arrow"
                    :class="{
                        'navigation-ban-btn': !isSelect,
                        'navigation-active-btn': clickBox == 'layer',
                        activeFunc: activeFunc == 'tabsLayer',
                    }"
                    :content="$t('tipsList.layer')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="handleShowBox('layer', $event)"
                >
                    <iconSymbol class="item-icon-center" name="layer"></iconSymbol>
                    <iconSymbol class="item-arrow" :name="'downArrow'"></iconSymbol>
                </div>
                <div
                    v-if="showToolList.includes('mirror')"
                    ref="mirrorIcon"
                    class="tab-block-item with-arrow"
                    :class="{
                        'navigation-ban-btn': !isSelect || (isSelect && isMMShape) || !canRotate || banMirror,
                        'navigation-active-btn': clickBox == 'mirror',
                        activeFunc: activeFunc == 'tabsMirror',
                    }"
                    :content="$t('mirror')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="handleShowBox('mirror', $event)"
                >
                    <iconSymbol class="item-icon-center" name="new-h-mirror"></iconSymbol>
                    <iconSymbol class="item-arrow" :name="'downArrow'"></iconSymbol>
                </div>

                <div
                    v-if="showToolList.includes('compose')"
                    ref="composeIcon"
                    class="tab-block-item"
                    :class="{
                        'navigation-ban-btn':
                            isSelectAllMMshape || isSelectAllGanttShape || isSelectAllTableShape || !(isSelect && (group || unGroup)),
                        'navigation-active-btn': clickBox == 'compose',
                        activeFunc: activeFunc == 'tabsGroup',
                    }"
                    :content="$t('tipsList.compose')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="handleShowBox('compose', $event)"
                >
                    <iconSymbol class="item-icon-center" name="new-compose"></iconSymbol>
                </div>
            </div>
            <!-- 锁定 一键美化 页面设置 搜索 -->
            <div
                class="tab-block-line"
                v-if="
                    showToolList.includes('protect') ||
                    showToolList.includes('autoFormat') ||
                    showToolList.includes('pageset') ||
                    showToolList.includes('search')
                "
            ></div>
            <div class="tab-block-box block-box-nomargin">
                <div
                    v-if="showToolList.includes('protect')"
                    ref="protectIcon"
                    class="tab-block-item with-arrow expand-tab-item"
                    :class="{
                        'navigation-ban-btn': !isSelect,
                        'navigation-active-btn': clickBox == 'protect',
                        activeFunc: activeFunc == 'tabsLock',
                        'lock-all': lockAllStatus,
                    }"
                    :content="$t(lockAllStatus ? 'tipsList.unprotect' : 'tipsList.protect')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="handleLockAll()"
                >
                    <span class="expand-tab-item-left">
                        <iconSymbol class="item-icon-center" name="protect"></iconSymbol>
                    </span>
                    <span class="expand-tab-item-right" @click.stop="handleShowBox('protect', $event)" v-if="!lockAllStatus">
                        <iconSymbol class="item-arrow" name="downArrow"></iconSymbol>
                    </span>
                </div>
                <div
                    v-if="showToolList.includes('autoFormat')"
                    ref="autoFormatIcon"
                    class="tab-block-item with-arrow"
                    :class="{
                        'navigation-ban-btn': !canReplaceClr && !canReplaceFlowClr,
                        'navigation-active-btn': clickBox == 'autoFormat',
                    }"
                    :content="$t('autoFormatList.autoFormatting')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="handleShowBox('autoFormat', $event)"
                >
                    <iconSymbol class="item-icon-center" name="autoFormat"></iconSymbol>
                    <iconSymbol class="item-arrow" name="downArrow"></iconSymbol>
                </div>
                <div
                    v-if="showToolList.includes('pageset')"
                    class="tab-block-item"
                    :content="$t('tipsList.pageset')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="handleShowBox('pageset', $event)"
                >
                    <iconSymbol class="item-icon-center" name="top-page-set" />
                </div>
                <div
                    v-if="showToolList.includes('search')"
                    ref="searchIcon"
                    class="tab-block-item"
                    :class="{ activeFunc: activeFunc == 'tabsReplace' }"
                    :content="$t('tipsList.search')"
                    v-tippy="{ placement: 'bottom' }"
                    @click="handleShowBox('search', $event)"
                >
                    <iconSymbol class="item-icon-center" name="search"></iconSymbol>
                </div>
            </div>

            <div class="tab-block-box moretool-btn" v-if="hiddenToolList.length > 0 && moreToolShow">
                <div ref="hiddenTool" class="tab-block-item" @click="showToolBox()">
                    <iconSymbol class="item-icon-center more-tool-icon color: var(--svg-color-p)" name="moreTool"></iconSymbol>
                    <div ref="appendBox" class="append-box" v-show="itemList['hiddenTool'].show && hiddenToolList.length > 0">
                        <div
                            v-if="hiddenToolList.includes('fontBtn')"
                            class="tab-block-item"
                            :class="{
                                'navigation-active-btn': isTextEditor,
                                activeFunc: activeFunc == 'tabsAddText',
                            }"
                            :content="$t('tipsList.text')"
                            v-tippy="{ placement: 'bottom' }"
                            @click="submitBoxItem('tool', 'Text')"
                        >
                            <iconSymbol class="item-icon-center" name="font1"></iconSymbol>
                        </div>
                        <div
                            v-if="hiddenToolList.includes('connector')"
                            ref="connectorIcon"
                            class="tab-block-item expand-tab-item"
                            :class="{
                                'navigation-active-btn': clickBox == 'connector',
                                activeFunc: activeFunc == 'tabsConnectLine',
                            }"
                            :content="$t('tipsList.connector')"
                            v-tippy="{ placement: 'bottom' }"
                            @click="handleShowBox('connector', $event)"
                        >
                            <iconSymbol class="item-icon-center" :name="`linkline${2 - conType + 1}`"></iconSymbol>
                            <iconSymbol class="item-arrow" name="downArrow"></iconSymbol>
                        </div>
                        <div
                            v-if="hiddenToolList.includes('colorFill')"
                            class="tab-block-item"
                            :class="{
                                'navigation-active-btn': fillColorWindow,
                                'navigation-ban-btn': (!fillColorWindow && !isSelect) || isMMShape,
                                activeFunc: activeFunc == 'tabsFillColor',
                            }"
                            :content="$t('tipsList.fillColor')"
                            v-tippy="{ placement: 'bottom' }"
                            @click="isSelect && !isMMShape && showFillColor($event)"
                        >
                            <iconSymbol
                                class="item-icon-center"
                                :name="`fillcolor${isDarkTheme() ? '-dark' : ''}`"
                                :style="`fill:${fillColor}`"
                            ></iconSymbol>
                        </div>

                        <div
                            v-if="hiddenToolList.includes('colorline')"
                            class="tab-block-item"
                            :class="{
                                'navigation-active-btn': lineColorWindow,
                                'navigation-ban-btn': (!lineColorWindow && !isSelect) || isMMShape,
                                activeFunc: activeFunc == 'tabsLineCoor',
                            }"
                            :content="$t('tipsList.lineColor')"
                            v-tippy="{ placement: 'bottom' }"
                            @click="isSelect && !isMMShape && showLineColor($event)"
                        >
                            <iconSymbol
                                class="item-icon-center"
                                :name="`fillline${isDarkTheme() ? '-dark' : ''}`"
                                :style="`fill:${lineColor}`"
                            ></iconSymbol>
                        </div>
                        <div
                            v-if="hiddenToolList.includes('lineSize')"
                            class="tab-block-item"
                            :content="$t('tipsList.lineSize')"
                            ref="lineSizeIcon"
                            v-tippy="{ placement: 'bottom' }"
                            @click="handleShowBox('lineSize', $event)"
                        >
                            <iconSymbol class="item-icon-center" name="float-lineweight"></iconSymbol>
                        </div>
                        <div
                            v-if="hiddenToolList.includes('lineType')"
                            class="tab-block-item"
                            ref="lineTypeIcon"
                            :content="$t('tipsList.lineType')"
                            v-tippy="{ placement: 'bottom' }"
                            @click="handleShowBox('lineType', $event)"
                        >
                            <iconSymbol class="item-icon-center" name="float-linestyle"></iconSymbol>
                        </div>
                        <div
                            v-if="hiddenToolList.includes('lineAnime')"
                            class="tab-block-item"
                            ref="lineAnimeIcon"
                            :content="$t('lineanimate')"
                            v-tippy="{ placement: 'bottom' }"
                            @click="handleShowBox('lineAnime', $event)"
                        >
                            <iconSymbol class="item-icon-center" name="float-lineanimate"></iconSymbol>
                        </div>
                        <div v-if="hiddenToolList.includes('leftArrow')" ref="leftArrowIcon" class="tab-block-item linebox-selectbox leftArrowTool">
                            <div
                                class="showbox"
                                :content="$t('tipsList.leftArrow')"
                                v-tippy="{ placement: 'bottom' }"
                                @click="handleShowBox('leftArrow', $event)"
                            >
                                <iconSymbol class="item-icon" :name="activeBeginTypeUrl()" />
                                <iconSymbol name="downArrow" class="icon-tiny-down icon-tiny-arrow" />
                            </div>
                        </div>
                        <div
                            v-if="hiddenToolList.includes('rightArrow')"
                            ref="rightArrowIcon"
                            class="tab-block-item linebox-selectbox rightArrowTool"
                        >
                            <div
                                class="showbox"
                                :content="$t('tipsList.rightArrow')"
                                v-tippy="{ placement: 'bottom' }"
                                @click="handleShowBox('rightArrow', $event)"
                            >
                                <iconSymbol class="item-icon rotate" :name="activeEndTypeUrl()" />
                                <iconSymbol name="downArrow" class="icon-tiny-down icon-tiny-arrow" />
                            </div>
                        </div>

                        <div
                            v-if="hiddenToolList.includes('layer')"
                            ref="layerIcon"
                            class="tab-block-item with-arrow"
                            :class="{
                                'navigation-ban-btn': !isSelect,
                                'navigation-active-btn': clickBox == 'layer',
                                activeFunc: activeFunc == 'tabsLayer',
                            }"
                            :content="$t('tipsList.layer')"
                            v-tippy="{ placement: 'bottom' }"
                            @click="handleShowBox('layer', $event)"
                        >
                            <iconSymbol class="item-icon-center" name="layer"></iconSymbol>
                            <iconSymbol class="item-arrow" :name="'downArrow'"></iconSymbol>
                        </div>
                        <div
                            v-if="hiddenToolList.includes('mirror')"
                            ref="mirrorIcon"
                            class="tab-block-item with-arrow"
                            :class="{
                                'navigation-ban-btn': !isSelect || (isSelect && isMMShape),
                                'navigation-active-btn': clickBox == 'mirror',
                                activeFunc: activeFunc == 'tabsMirror',
                            }"
                            :content="$t('mirror')"
                            v-tippy="{ placement: 'bottom' }"
                            @click="handleShowBox('mirror', $event)"
                        >
                            <iconSymbol class="item-icon-center" name="new-h-mirror"></iconSymbol>
                            <iconSymbol class="item-arrow" :name="'downArrow'"></iconSymbol>
                        </div>
                        <div
                            v-if="hiddenToolList.includes('compose')"
                            ref="composeIcon"
                            class="tab-block-item"
                            :class="{
                                'navigation-ban-btn': isSelectAllMMshape || !(isSelect && (group || unGroup)),
                                'navigation-active-btn': clickBox == 'compose',
                                activeFunc: activeFunc == 'tabsGroup',
                            }"
                            :content="$t('tipsList.compose')"
                            v-tippy="{ placement: 'bottom' }"
                            @click="handleShowBox('compose', $event)"
                        >
                            <iconSymbol class="item-icon-center" name="new-compose"></iconSymbol>
                        </div>
                        <div
                            v-if="hiddenToolList.includes('protect')"
                            ref="protectIcon"
                            class="tab-block-item with-arrow expand-tab-item"
                            :class="{
                                'navigation-ban-btn': !isSelect,
                                'navigation-active-btn': clickBox == 'protect',
                                activeFunc: activeFunc == 'tabsLock',
                                'lock-all': lockAllStatus,
                            }"
                            :content="$t(lockAllStatus ? 'tipsList.unprotect' : 'tipsList.protect')"
                            v-tippy="{ placement: 'bottom' }"
                            @click="handleLockAll()"
                        >
                            <span class="expand-tab-item-left">
                                <iconSymbol class="item-icon-center" name="protect"></iconSymbol>
                            </span>
                            <span class="expand-tab-item-right" @click.stop="handleShowBox('protect', $event)" v-if="!lockAllStatus">
                                <iconSymbol class="item-arrow" name="downArrow"></iconSymbol>
                            </span>
                        </div>
                        <div
                            v-if="hiddenToolList.includes('autoFormat')"
                            ref="autoFormatIcon"
                            class="tab-block-item with-arrow"
                            :class="{
                                'navigation-ban-btn': !canReplaceClr && !canReplaceFlowClr,
                                'navigation-active-btn': clickBox == 'autoFormat',
                            }"
                            :content="$t('autoFormatList.autoFormatting')"
                            v-tippy="{ placement: 'bottom' }"
                            @click="handleShowBox('autoFormat', $event)"
                        >
                            <iconSymbol class="item-icon-center" name="autoFormat"></iconSymbol>
                            <iconSymbol class="item-arrow" name="downArrow"></iconSymbol>
                        </div>
                        <div
                            v-if="hiddenToolList.includes('pageset')"
                            class="tab-block-item"
                            :content="$t('tipsList.pageset')"
                            v-tippy="{ placement: 'bottom' }"
                            @click="handleShowBox('pageset', $event)"
                        >
                            <iconSymbol class="item-icon-center" name="top-page-set" />
                        </div>
                        <div
                            v-if="hiddenToolList.includes('search')"
                            ref="searchIcon"
                            class="tab-block-item"
                            :class="{ activeFunc: activeFunc == 'tabsReplace' }"
                            :content="$t('tipsList.search')"
                            v-tippy="{ placement: 'bottom' }"
                            @click="handleShowBox('search', $event)"
                        >
                            <iconSymbol class="item-icon-center" name="search"></iconSymbol>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-append-box tab-block-box">
                <transition name="tabmodaltrans">
                    <div
                        class="blockItem-list padding-list connector-list"
                        ref="connector"
                        v-show="itemList['connector'].show"
                        :style="{
                            left: `${clickLeft + offsetLeft}px`,
                            top: `${clickTop + 32 + offsetTop}px`,
                        }"
                    >
                        <div
                            class="arrowItem-li"
                            :class="{ 'active-li': item.id == connectBackup }"
                            v-for="item in connectorList"
                            :key="item.id"
                            @click.stop="clickBoxItem('connector', item.id)"
                            @mouseenter="previewConnect(item.id)"
                            @mouseleave="recoverConnect()"
                        >
                            <iconSymbol class="item-icon" :name="item.name"></iconSymbol>
                            <p>{{ $t(item.text) }}</p>
                            <span>{{ item.hotkey }}</span>
                        </div>
                    </div>
                </transition>
                <transition name="tabmodaltrans">
                    <div
                        class="blockItem-list padding-list line-size-list"
                        ref="lineSize"
                        v-show="itemList['lineSize'].show"
                        :style="{
                            left: `${clickLeft + offsetLeft}px`,
                            top: `${clickTop + 32 + offsetTop}px`,
                        }"
                    >
                        <div
                            class="arrowItem-li"
                            v-for="(item, index) in lineSize"
                            :key="index"
                            :class="{ 'active-li': lineWidth == item.value }"
                            @click="clickBoxItem('lineSize', item.value)"
                            @mouseenter="startPreview('lineSize', item.value)"
                            @mouseleave="endPreview"
                        >
                            <div class="lineheight-preview" :style="{ height: `${item.value}px` }"></div>
                            <span>{{ item.label + " pt" }}</span>
                        </div>
                        <div class="splice-line" v-if="isSelect"></div>
                        <div class="arrowItem-li" @click="moreLineSetting" v-if="isSelect">
                            <iconSymbol class="item-icon" name="float-lineweight" />
                            {{ $t("tipsList.otherWeight") }}
                        </div>
                    </div>
                </transition>
                <transition name="tabmodaltrans">
                    <div
                        class="blockItem-list linebox-selector line-begin"
                        ref="leftArrow"
                        :style="{
                            left: `${clickLeft + offsetLeft}px`,
                        }"
                        v-show="itemList['leftArrow'].show"
                    >
                        <div class="line-title">{{ $t("tipsList.arrowSize") }}</div>
                        <div class="line-size">
                            <LineSlider ref="BeginSlider" v-model="beginSize" :step="1" :max="7" :min="1" @on-change="changeBeginSize()"></LineSlider>
                        </div>
                        <div class="line"></div>
                        <ScrollView class="line-type-wrapper">
                            <div class="line-type-content">
                                <div
                                    class="item-down begindown"
                                    v-for="n in 50"
                                    :class="{ active: activeBeginType + 1 == n }"
                                    :key="n"
                                    @click.stop="setBeginType(n - 1)"
                                >
                                    <iconSymbol class="full arrowtype" :name="activeBeginTypeUrl(n - 1)" />
                                    <div class="border"></div>
                                </div>
                            </div>
                        </ScrollView>
                    </div>
                </transition>
                <transition name="tabmodaltrans">
                    <div
                        class="blockItem-list linebox-selector line-end"
                        ref="rightArrow"
                        :style="{
                            left: `${clickLeft + offsetLeft}px`,
                        }"
                        v-show="itemList['rightArrow'].show"
                    >
                        <div class="line-title">{{ $t("tipsList.arrowSize") }}</div>
                        <div class="line-size">
                            <LineSlider ref="EndSlider" v-model="endSize" :step="1" :max="7" :min="1" @on-change="changeEndSize()"></LineSlider>
                        </div>
                        <div class="line"></div>
                        <ScrollView class="line-type-wrapper">
                            <div class="line-type-content">
                                <div
                                    class="item-down enddown"
                                    v-for="n in 50"
                                    :class="{ active: activeEndType + 1 == n }"
                                    :key="n"
                                    @click.stop="setEndType(n - 1)"
                                >
                                    <iconSymbol class="full rotate arrowtype" :name="activeEndTypeUrl(n - 1)" />
                                    <div class="border"></div>
                                </div>
                            </div>
                        </ScrollView>
                    </div>
                </transition>
                <transition name="tabmodaltrans">
                    <div
                        class="blockItem-list padding-list line-type-list"
                        ref="lineType"
                        v-show="itemList['lineType'].show"
                        :style="{
                            left: `${clickLeft + offsetLeft}px`,
                            top: `${clickTop + 32 + offsetTop}px`,
                        }"
                    >
                        <div
                            class="arrowItem-li"
                            v-for="item in 23"
                            :key="item"
                            :class="{ 'active-li': activeDashType == (item === 1 ? 0 : item) }"
                            @click="clickBoxItem('lineType', item)"
                            @mouseenter="startPreview('lineType', item)"
                            @mouseleave="endPreview"
                        >
                            <iconSymbol class="item-icon" :name="activeDashTypeUrl(item)"></iconSymbol>
                            <span>{{ item - 1 < 10 ? "0" + (item - 1) : item - 1 }}</span>
                        </div>
                    </div>
                </transition>
                <transition name="tabmodaltrans">
                    <div
                        class="blockItem-list padding-list line-anime-list"
                        ref="lineAnime"
                        v-show="itemList['lineAnime'].show"
                        :style="{
                            left: `${clickLeft + offsetLeft}px`,
                            top: `${clickTop + 32 + offsetTop}px`,
                        }"
                    >
                        <div class="set-box switch-set">
                            <div class="switch-title">
                                <span>
                                    <span class="title">{{ $t("openanimate") }}</span>
                                    <Tooltip class="line-animate-tip" v-if="!vip && isSelect && isLine" placement="top" :transfer="true">
                                        <VipIcon />
                                        <template #content>
                                            <div class="line-animate-tip-content">
                                                <span>{{ $t("limit2lines") }}</span>
                                                <span class="to-vip" @click.stop="showBuyframe('flowAnimitionllimit')">{{ $t("tovip") }}</span>
                                            </div>
                                        </template>
                                    </Tooltip>
                                </span>
                                <i-switch
                                    :value="showLineAnimate"
                                    v-if="isSelect && isLine"
                                    size="small"
                                    @on-change="changeShowLineAnimate"
                                    ref="switchRef"
                                />
                            </div>
                            <div class="switch-default">
                                <Checkbox
                                    class="switch-box"
                                    ref="openRef"
                                    :value="autoShowConnectAnimation"
                                    @on-change="changeAutoShowConnectAnimation"
                                >
                                    {{ $t("deafultopen") }}
                                </Checkbox>
                            </div>
                        </div>
                        <div class="set-box property-set">
                            <div class="style-title">{{ $t("styleset") }}</div>
                            <div class="style-set-box">
                                <div class="left">{{ $t("anistyle") }}:</div>
                                <i-select class="selecter" v-model="animateStyle" size="small">
                                    <i-option :value="0">{{ $t("aniarrow") }}</i-option>
                                    <i-option :value="1">{{ $t("anicircle") }}</i-option>
                                </i-select>
                            </div>
                            <div class="style-set-box">
                                <div class="left">{{ $t("anispeed") }}:</div>
                                <i-select class="selecter" v-model="animateSpeed" size="small" :placement="densityPlacement">
                                    <i-option :value="0">{{ $t("anifast") }}</i-option>
                                    <i-option :value="1">{{ $t("animedium") }}</i-option>
                                    <i-option :value="2">{{ $t("anislow") }}</i-option>
                                </i-select>
                            </div>
                            <div class="style-set-box">
                                <div class="left">{{ $t("anidensity") }}:</div>
                                <i-select class="selecter" v-model="animateDensity" size="small" :placement="densityPlacement">
                                    <i-option :value="0">{{ $t("anilarge") }}</i-option>
                                    <i-option :value="1">{{ $t("animedium") }}</i-option>
                                    <i-option :value="2">{{ $t("anifew") }}</i-option>
                                </i-select>
                            </div>
                            <div class="style-set-box">
                                <div class="left">{{ $t("anicolor") }}:</div>
                                <div class="color-set" @click="showPalette">
                                    <div class="color-preview" :style="{ backgroundColor: animateColor }"></div>
                                </div>
                            </div>
                            <div class="style-set-box">
                                <div class="left">{{ $t("anidirection") }}:</div>
                                <i-select class="selecter" v-model="animateDirection" size="small" :placement="directionPlacement">
                                    <i-option :value="0">{{ $t("aniforward") }}</i-option>
                                    <i-option :value="1">{{ $t("anireverse") }}</i-option>
                                </i-select>
                            </div>
                        </div>
                        <div class="set-box show-set">
                            <div class="show-title">{{ $t("showtime") }}</div>
                            <RadioGroup class="label-box-radio" v-model="animateShowTime">
                                <Radio class="label-box-radioitem" :key="$t('openshow')" :label="0">
                                    <span>{{ $t("openshow") }}</span>
                                </Radio>
                                <Radio class="label-box-radioitem" :key="$t('clickshow')" :label="1">
                                    <span>{{ $t("clickshow") }}</span>
                                </Radio>
                            </RadioGroup>
                        </div>
                    </div>
                </transition>
                <transition name="tabmodaltrans">
                    <div
                        class="blockItem-list padding-list mirror-list"
                        ref="layer"
                        v-show="itemList['layer'].show"
                        :style="{
                            left: `${clickLeft + offsetLeft}px`,
                            top: `${clickTop + 32 + offsetTop}px`,
                        }"
                    >
                        <div
                            class="arrowItem-li"
                            v-for="item in layerList"
                            :key="item.id"
                            :class="{ activeFunc: item.func == activeFunc }"
                            @click="clickBoxItem('layout', item.id)"
                        >
                            <iconSymbol class="item-icon" :name="item.name"></iconSymbol>
                            <span>{{ $t(`tipsList.${item.name}`) }}</span>
                        </div>
                    </div>
                </transition>

                <transition name="tabmodaltrans">
                    <div
                        class="blockItem-list padding-list mirror-list"
                        ref="mirror"
                        v-show="itemList['mirror'].show"
                        :style="{
                            left: `${clickLeft + offsetLeft}px`,
                            top: `${clickTop + 32 + offsetTop}px`,
                        }"
                    >
                        <div
                            class="arrowItem-li"
                            v-for="item in mirrorList"
                            :key="item.id"
                            :class="{ activeFunc: item.func == activeFunc }"
                            @click="
                                () => {
                                    !canRotate ? '' : clickBoxItem('align', item.id);
                                }
                            "
                        >
                            <iconSymbol class="item-icon" :class="{ 'ban-btn': !canRotate }" :name="item.name"></iconSymbol>
                            <span>{{ $t(item.text) }}</span>
                        </div>
                    </div>
                </transition>

                <transition name="tabmodaltrans">
                    <div
                        class="blockItem-alignbox"
                        ref="align"
                        v-show="itemList['align'].show"
                        :style="{
                            left: `${clickLeft + offsetLeft}px`,
                            top: `${clickTop + 32 + offsetTop}px`,
                        }"
                    >
                        <ul class="blockItem-btnBox">
                            <li
                                v-for="item in alignList"
                                :key="item.id"
                                :class="{
                                    'navigation-ban-btn': !isMultiSel || ([6, 7].includes(item.id) && multiSelCount < 3),
                                }"
                                :content="$t(`tipsList.${item.name}`)"
                                v-tippy="{ placement: 'bottom' }"
                                @click="isMultiSel && clickBoxItem('align', item.id)"
                            >
                                <iconSymbol class="item-icon" :name="item.name"></iconSymbol>
                            </li>
                        </ul>
                        <ul class="blockItem-btnBox">
                            <li
                                v-for="item in sameList"
                                :key="item.id"
                                :class="{ 'navigation-ban-btn': !isMultiSel }"
                                :content="$t(`tipsList.${item.name}`)"
                                v-tippy="{ placement: 'bottom' }"
                                @click="isMultiSel && sameFuc(item.name)"
                            >
                                <iconSymbol class="item-icon" :name="item.name"></iconSymbol>
                            </li>
                        </ul>
                    </div>
                </transition>

                <transition name="tabmodaltrans">
                    <ul
                        class="blockItem-composebox"
                        ref="compose"
                        v-show="itemList['compose'].show"
                        :style="{
                            left: `${clickLeft + offsetLeft}px`,
                            top: `${clickTop + 32 + offsetTop}px`,
                        }"
                    >
                        <li
                            class="compose-box"
                            :class="{ 'navigation-ban-btn': !group || containOrgShape }"
                            @click="
                                () => {
                                    !group || containOrgShape ? '' : clickBoxItem('compose', 0);
                                }
                            "
                        >
                            <div class="compose-box-left">
                                <iconSymbol class="item-icon compose" name="new-compose"></iconSymbol>
                                <p>{{ $t("compose") }}</p>
                            </div>
                            <span>Ctrl+G</span>
                        </li>
                        <li
                            class="compose-box"
                            :class="{ 'navigation-ban-btn': !unGroup }"
                            @click="
                                () => {
                                    !unGroup ? '' : clickBoxItem('compose', 1);
                                }
                            "
                        >
                            <div class="compose-box-left">
                                <iconSymbol class="item-icon ungroup" name="new-ungroup"></iconSymbol>
                                <p>{{ $t("uncompose") }}</p>
                            </div>
                            <span>Ctrl+Shift+G</span>
                        </li>
                    </ul>
                </transition>

                <div
                    class="blockItem-themebox"
                    ref="theme"
                    v-show="itemList['theme'].show"
                    :style="{
                        left: `${clickLeft + offsetLeft}px`,
                        top: `${clickTop + 32 + offsetTop}px`,
                    }"
                >
                    <QuickStyleBox :type="'All'"></QuickStyleBox>
                </div>
                <transition name="tabmodaltrans">
                    <ul
                        class="blockItem-protectbox"
                        ref="protect"
                        v-show="itemList['protect'].show"
                        :style="{
                            left: `${clickLeft + offsetLeft}px`,
                            top: `${clickTop + 32 + offsetTop}px`,
                        }"
                    >
                        <li
                            :class="{
                                'checked-menu-item': lockStatus[item.name],
                                'after-line': item.afterLine,
                            }"
                            v-for="item in protectList"
                            :key="item.id"
                            @click="clickBoxItem('protect', item.id)"
                        >
                            <p>{{ $t(item.text) }}</p>
                        </li>
                    </ul>
                </transition>

                <NavigationDragBox
                    class="search-box"
                    :dragTitle="$t('dragTitle')"
                    :originPostion="{
                        left: `${dragboxLeft + offsetLeft}px`,
                        top: `${dragboxTop + offsetTop + 32}px`,
                    }"
                    :showModal="itemList['search'].show"
                    :style="{
                        left: `${dragboxLeft + offsetLeft}px`,
                        top: `${dragboxTop + offsetTop + 32}px`,
                    }"
                    :lockBox="lockBox"
                    @changeLock="changeLock($event)"
                    @removeCloseEvent="removeCloseListener()"
                    @closeBox="closeBoxByName('search')"
                >
                    <div class="search-content" ref="search" id="searchtBox">
                        <div class="search-line">
                            <p class="search-title">{{ $t("search") }}:</p>
                            <Input
                                v-model="searchInput"
                                size="small"
                                ref="searchInputBox"
                                @on-focus="editLocker('focus', 'lockInput')"
                                @on-blur="
                                    editLocker('blur', 'lockInput', () => {
                                        submitBoxItem('search', 0);
                                    })
                                "
                                @keyup.enter.native="
                                    () => {
                                        iviewInputBlur($event);
                                    }
                                "
                            ></Input>
                            <div class="search-tool">
                                <div @click="submitBoxItem('search', 1)">
                                    <iconSymbol
                                        class="item-icon-center searchLeft"
                                        :name="EDCONFIG.DEFAULT_THEME === 'dark' ? 'searchLeft-dark' : 'searchLeft'"
                                    ></iconSymbol>
                                </div>
                                <div @click="submitBoxItem('search', 2)">
                                    <iconSymbol
                                        class="item-icon-center searchRight"
                                        :name="EDCONFIG.DEFAULT_THEME === 'dark' ? 'searchRight-dark' : 'searchRight'"
                                    ></iconSymbol>
                                </div>
                                <p class="tool-text">{{ searchResult }}</p>
                            </div>
                        </div>
                        <div class="search-line">
                            <p class="search-title">{{ $t("replace") }}:</p>
                            <Input
                                v-model="replaceInput"
                                size="small"
                                @on-focus="editLocker('focus', 'lockInput')"
                                @on-blur="editLocker('blur', 'lockInput', () => {})"
                            ></Input>
                            <div
                                class="search-btn"
                                :content="$t('tipsList.replace')"
                                v-tippy="{ placement: 'bottom' }"
                                @click="submitBoxItem('replace', 0)"
                            >
                                <iconSymbol class="item-icon" name="searchBtn2"></iconSymbol>
                            </div>
                            <div
                                class="search-btn"
                                :content="$t('tipsList.replaceAll')"
                                v-tippy="{ placement: 'bottom' }"
                                @click="submitBoxItem('replace', 1)"
                            >
                                <iconSymbol class="item-icon" name="searchBtn3"></iconSymbol>
                            </div>
                        </div>
                        <ul class="search-checkbox">
                            <li v-for="checkbox in searchList" :key="checkbox.id">
                                <Checkbox
                                    :disabled="checkbox.id == 2 && hasCN"
                                    class=""
                                    v-model="checkbox.checked"
                                    @on-change="clickCheckBox(checkbox.id)"
                                >
                                    {{ $t(checkbox.name) }}
                                </Checkbox>
                            </li>
                        </ul>
                    </div>
                </NavigationDragBox>
                <transition name="tabmodaltrans">
                    <ul
                        class="blockItem-composebox"
                        ref="autoFormat"
                        v-show="itemList['autoFormat'].show"
                        :style="{
                            left: `${clickLeft + offsetLeft}px`,
                            top: `${clickTop + 32 + offsetTop}px`,
                        }"
                    >
                        <li
                            v-for="item in autoFormatList"
                            :key="item.id"
                            @click.stop="clickBoxItem('autoFormat', item.id)"
                            :class="{
                                'navigation-ban-btn': (item.id == 0 && !canReplaceFlowClr) || (item.id == 1 && !canReplaceClr),
                                activeFunc: activeFunc == item.func_name,
                            }"
                            class="autoformat-box"
                        >
                            <div class="autoformat-left">
                                <iconSymbol class="item-icon" :class="item.name" :name="item.name"></iconSymbol>
                                <p>{{ $t(item.text) }}</p>
                            </div>
                            <iconSymbol
                                class="vip-point"
                                :name="`vip-point${EDCONFIG.IS_SDK ? '-sdk' : ''}`"
                                v-if="showAutoFormatVipIcon && item.id == 0"
                            ></iconSymbol>
                        </li>
                    </ul>
                </transition>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import checkMindmap from "@/app/utils/checkMindmap";

    declare var eLock: any;
    declare var EDOpeAssist: any;
    declare var eUndo: any;
    declare var getTextEditor: any;
    declare var Theme: any;
    declare var eFmtSetFlag: any;
    declare var UnitUtil: any;
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import NavigationFont from "./NavigationFont.vue";
    import NavigationDragBox from "./NavigationDragBox.vue";

    import QuickStyleBox from "../Modals/QuickStyleBox.vue";
    import ScrollView from "@/public/components/ScrollView/ScrollView.vue";
    import LineSlider from "../Common/RightTabs/LineSlider.vue";
    import { AnimeOPe } from "@/app/types";

    enum ArrowSize {
        "Very Small" = 2,
        Small = 3,
        Middle = 4,
        Large = 6,
        "Extra Large" = 9,
        Jumbo = 12,
        Colossal = 14,
    }
    enum JumpMode {
        None,
        Horizontal,
        Vertical,
    }
    enum JumpStyle {
        Arc,
        Gap,
        Square,
        Point2,
        Point3,
    }
    enum ElectricalCrossStyle {
        None,
        Point,
    }
    enum DropType {
        undo,
        clip,
        select,
        text,
        connector,
        frontOrder,
        backOrder,
        rotate,
        align,
        group,
        size,
        distribute,
    }
    declare var eToolType: any;
    declare var eOrderAct: any;
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            NavigationFont,
            NavigationDragBox,
            QuickStyleBox,
            ScrollView,
            LineSlider,
        },
    })
    export default class Navigation extends Vue {
        @Inject()
        ["iviewInputBlur"];
        @Inject()
        ["showMessage"];

        clickLeft: number = 0;
        clickTop: number = 6;
        dragboxLeft: number = 0;
        draglayoutboxLeft: number = 0;
        draglayoutboxTop: number = 0;
        dragacqboxLeft: number = 0;
        dragacqboxTop: number = 0;
        dragboxTop: number = 0;
        offsetLeft: number = 0;
        offsetTop: number = 0;
        moreToolShow: boolean = false;
        connectorList: Array<object> = [
            {
                id: 0,
                text: "connectorList.linkLine1",
                name: "linkline1",
                hotkey: "Ctrl+3",
            },
            {
                id: 1,
                text: "connectorList.linkLine2",
                name: "linkline2",
                hotkey: "Ctrl+4",
            },
            {
                id: 2,
                text: "connectorList.linkLine3",
                name: "linkline3",
                hotkey: "Ctrl+5",
            },
        ];
        // 粗细
        lineSize = [
            {
                value: 0.25,
                label: "0.25",
            },
            {
                value: 0.75,
                label: "0.75",
            },
            {
                value: 1,
                label: "1.00",
            },
            {
                value: 1.5,
                label: "1.50",
            },
            {
                value: 2.25,
                label: "2.25",
            },
            {
                value: 3,
                label: "3.00",
            },
            {
                value: 4,
                label: "4.00",
            },
            {
                value: 5,
                label: "5.00",
            },
            {
                value: 6,
                label: "6.00",
            },
        ];
        selectLineSize(data) {
            let view = window["_view"];
            let payload = {
                _width: data,
            };
            this.lineWidth = data;
            if (this.isSelect) {
                view.setFmt(payload, eFmtSetFlag.LineWidth);
            } else {
                this.changePageConnectLine({
                    type: "lineW",
                    data: this.lineWidth,
                });
            }
        }
        moreLineSetting() {
            if (this.activeRightPanelKey !== "shapeP") {
                this.$bus.$emit("changeRightView", "shapeP", false, "other");
            }
            this.$store.commit("setStatus", {
                type: "newActiveType",
                data: this.$store.state.ui.fmtType.styleSet,
            });
            this.$nextTick(() => {
                this.$bus.$emit("rightStylePanelScrollTo", "line");
            });
            this.closeBoxByName("lineSize");
        }

        selectLineStyle(index) {
            let view = window["_view"];
            if (this.isSelect) {
                view.setFmt(
                    {
                        _dash: index,
                    },
                    eFmtSetFlag.LineDash
                );
            } else {
                this.changePageConnectLine({
                    type: "lineStyle",
                    data: index == 1 ? index - 1 : index,
                });
            }
        }

        // 预览
        startPreview(type, value) {
            let view = window["_view"];
            if (!this.isSelect) return;
            switch (type) {
                case "lineSize":
                    view.setlineFmtwidth(value, true);
                    break;
                case "lineType":
                    view.setlineFmtDash(value, true);
                    break;
            }
        }
        endPreview() {
            window["_view"].hoverLeava();
        }

        @Watch("activeBSType")
        watchActiveBSType(nv, ov) {
            if (nv <= 4) {
                this.beginSize = nv - 1;
            } else if (nv === 14) {
                this.beginSize = 7;
            } else {
                this.beginSize = (nv + 6) / 3;
            }
        }

        @Watch("activeESType")
        watchActiveESType(nv, ov) {
            if (nv <= 4) {
                this.endSize = nv - 1;
            } else if (nv === 14) {
                this.endSize = 7;
            } else {
                this.endSize = (nv + 6) / 3;
            }
        }

        setBeginType(index) {
            let view = window["_view"];
            if (this.isSelect) {
                view.setFmt(
                    {
                        _type: index,
                    },
                    eFmtSetFlag.LineBAType
                );
            } else {
                this.changePageConnectLine({
                    type: "BArrow",
                    data: index,
                });
            }
            this.trackClick("clickStart");
            this.itemList["acquiesceStyle"].showList = false;
        }
        setEndType(index) {
            let view = window["_view"];
            if (this.isSelect) {
                view.setFmt(
                    {
                        _type: index,
                    },
                    eFmtSetFlag.LineEAType
                );
            } else {
                this.changePageConnectLine({
                    type: "EArrow",
                    data: index,
                });
            }
            this.trackClick("clickEnd");
            this.itemList["acquiesceStyle"].showList = false;
        }

        changeBeginSize() {
            this.$nextTick(() => {
                let n = this.beginSize;
                let view = window["_view"];
                let newSize = n;
                if (n <= 3) {
                    newSize = n + 1;
                } else if (n <= 6) {
                    newSize = 3 * n - 6;
                } else {
                    newSize = 14;
                }
                if (this.isSelect) {
                    view.setFmt(
                        {
                            _size: newSize,
                        },
                        eFmtSetFlag.LineBASize
                    );
                } else {
                    this.changePageConnectLine({
                        type: "BText",
                        data: newSize,
                    });
                }
                this.activeBSType = newSize;
                this.trackClick("clickStart");
            });
        }
        changeEndSize() {
            this.$nextTick(() => {
                let n = this.endSize;
                let view = window["_view"];
                let newSize = n;

                if (n <= 3) {
                    newSize = n + 1;
                } else if (n <= 6) {
                    newSize = 3 * n - 6;
                } else {
                    newSize = 14;
                }
                if (this.isSelect) {
                    view.setFmt(
                        {
                            _size: newSize,
                        },
                        eFmtSetFlag.LineEASize
                    );
                } else {
                    this.changePageConnectLine({
                        type: "EText",
                        data: newSize,
                    });
                }
                this.activeESType = newSize;
                this.trackClick("clickEnd");
            });
        }
        alignList: Array<object> = [
            {
                id: 0,
                text: "",
                name: "align01",
            },
            {
                id: 1,
                text: "",
                name: "align02",
            },
            {
                id: 2,
                text: "",
                name: "align03",
            },
            {
                id: 6,
                text: "",
                name: "align07",
            },
            {
                id: 3,
                text: "",
                name: "align04",
            },
            {
                id: 4,
                text: "",
                name: "align05",
            },
            {
                id: 5,
                text: "",
                name: "align06",
            },
            {
                id: 7,
                text: "",
                name: "align08",
            },
        ];
        layerList: Array<{ id: number; text: string; name: string; func: string }> = [
            {
                id: 0,
                text: "",
                name: "new-layer1",
                func: "tabsMoveTop",
            },
            {
                id: 1,
                text: "",
                name: "new-layer2",
                func: "tabsMoveBottom",
            },
            {
                id: 2,
                text: "",
                name: "new-layer3",
                func: "tabsMoveUp",
            },
            {
                id: 3,
                text: "",
                name: "new-layer4",
                func: "tabsMoveDown",
            },
        ];
        mirrorList: Array<{ id: number; text: string; name: string; func: string }> = [
            {
                id: 8,
                text: "hMirror",
                name: "new-h-mirror",
                func: "tabsHMirror",
            },
            {
                id: 9,
                text: "vMirror",
                name: "new-v-mirror",
                func: "tabsVMirror",
            },
        ];
        protectList: Array<any> = [
            {
                id: 0,
                text: "protectList.width",
                name: "Width",
            },
            {
                id: 1,
                text: "protectList.height",
                name: "Height",
            },
            {
                id: 2,
                text: "protectList.ratio",
                name: "WHCalc",
                afterLine: true,
            },
            // -----------  //
            {
                id: 3,
                text: "protectList.horizontal",
                name: "X",
            },
            {
                id: 4,
                text: "protectList.vertical",
                name: "Y",
                afterLine: true,
            },
            // -----------  //
            {
                id: 5,
                text: "protectList.rotate",
                name: "Rotate",
                afterLine: true,
            },
            // -----------  //
            {
                id: 6,
                text: "protectList.begin",
                name: "Begin",
            },
            {
                id: 7,
                text: "protectList.end",
                name: "End",
                afterLine: true,
            },
            // -----------  //
            {
                id: 9,
                text: "protectList.text",
                name: "TextEdit",
            },
            {
                id: 13,
                text: "protectList.format",
                name: "Format",
                afterLine: true,
            },
            // -----------  //
            // {
            //     id: 10,
            //     text: "protectList.select",
            //     name: "Select",
            // },
            {
                id: 11,
                text: "protectList.delete",
                name: "Delete",
            },
            {
                id: 12,
                text: "protectList.link",
                name: "Connector",
                afterLine: true,
            },
            // -----------  //
            {
                id: 8,
                text: "protectList.group",
                name: "Group",
            },
            {
                id: 14,
                text: "protectList.groupFormat",
                name: "GrpFmt_Format",
            },
            {
                id: 16,
                text: "protectList.theme",
                name: "From_Theme",
                afterLine: true,
            },
            // -----------  //
            {
                id: -1,
                text: "protectList.unlock",
                name: "unlock",
            },
        ];
        searchList: Array<object> = [
            {
                id: 0,
                checked: false,
                name: "searchList.caseSensitive",
            },
            {
                id: 1,
                checked: false,
                name: "searchList.allPage",
            },
            {
                id: 2,
                checked: false,
                name: "searchList.fullMatch",
            },
        ];
        sameList: Array<object> = [
            {
                id: 0,
                text: "",
                name: "sameWidth",
            },
            {
                id: 1,
                text: "",
                name: "sameHeight",
            },
            {
                id: 2,
                text: "",
                name: "sameAngle",
            },
            {
                id: 3,
                text: "",
                name: "sameSize",
            },
        ];
        autoFormatList: Array<any> = [
            {
                id: 0,
                text: "autoFormatList.autoFormatting",
                name: "autoFormat",
                func_name: "tabsBeautify",
            },
            {
                id: 1,
                text: "autoFormatList.ReplaceClr",
                name: "replaceClr",
                func_name: "tabsReplaceClr",
            },
        ];
        clickBox: string = ""; // 当前点击的盒子
        tempClickBox: string = ""; // 上一次点击的盒子
        itemList: object = {
            align: {
                // 文本排列
                show: false,
            },
            connector: {
                show: false,
            },
            lineSize: {
                show: false,
            },
            lineType: {
                show: false,
            },
            lineAnime: {
                show: false,
            },
            leftArrow: {
                show: false,
            },
            rightArrow: {
                show: false,
            },
            layer: {
                show: false,
            },
            mirror: {
                show: false,
            },
            layout: {
                // 布局方式
                show: false,
            },
            colorFill: {
                color: "#ffffff",
            },
            colorline: {
                color: "#ffffff",
            },
            compose: {
                show: false,
                canCompose: false,
                canUnCompose: false,
            },
            search: {
                show: false,
                searchInput: "",
                replaceInput: "",
            },
            protect: {
                show: false,
            },
            theme: {
                show: false,
                active: 0,
                styleList: [],
            },
            acquiesceStyle: {
                show: false,
                showList: false,
                showListType: "",
                lineWidth: 0,
                radius: 0,
                style: 0,
                linkline: 0,
                pointType: 0,
                pointStyle: 0,
                arrowSizeList: [
                    {
                        id: 0,
                        text: "Very Small",
                    },
                    {
                        id: 1,
                        text: "Small",
                    },
                    {
                        id: 2,
                        text: "Middle",
                    },
                    {
                        id: 3,
                        text: "Large",
                    },
                    {
                        id: 4,
                        text: "Extra Large",
                    },
                    {
                        id: 5,
                        text: "Jumbo",
                    },
                    {
                        id: 6,
                        text: "Colossal",
                    },
                ],
                pointTypeList: [
                    {
                        id: 0,
                        text: "无",
                    },
                    {
                        id: 1,
                        text: "水平线",
                    },
                    {
                        id: 2,
                        text: "垂直线",
                    },
                ],
                pointStyleList: [
                    {
                        id: 0,
                        text: "弧线",
                    },
                    {
                        id: 1,
                        text: "间隙",
                    },
                    {
                        id: 2,
                        text: "正方形",
                    },
                    {
                        id: 3,
                        text: "两面",
                    },
                    {
                        id: 4,
                        text: "三面",
                    },
                ],
            },
            option: {
                show: false,
                locker: false,
                type: "orgchart",
            },
            hiddenTool: {
                show: false,
            },
            swimTitle: {
                show: false,
                posList: ["swimMainTitle.None", "swimMainTitle.Top", "swimMainTitle.Left"],
            },
            autoFormat: {
                show: false,
            },
        };

        toolTimer: boolean = false; //节流
        showToolList: Array<string> = [];
        hiddenToolList: Array<string> = [];

        searchInput: string = "";
        replaceInput: string = "";
        // optiion
        lockInput: boolean = false;

        layoutOffset: number = 0;
        alignOffset: number = 0;
        themeOffset: number = 0;
        acquiesceStyleOffset: number = 0;
        searchOffset: number = 0;

        // search
        hasCN: boolean = false; // 输入项有中文字符
        searchResult: string = "";
        searchTimer: number = 0;
        lockBox: boolean = false;
        layoutlockBox: boolean = false;
        acqlockBox: boolean = false;
        timer: number = 0;
        showSearchTimer: number = 0;

        isSpecialFlag: number = 0; // 特殊设置手动关闭后设置为1
        connectBackup: number = 0; // 连接线预览备份

        beginSize: number = 2;
        endSize: number = 2;

        get activeSpecStyle() {
            if (!this.isSpecial || !this.itemList["option"].show) {
                return {
                    fill: "#424242",
                };
            } else {
                return {
                    fill: "#017eff",
                };
            }
        }
        get containOrgShape() {
            return this.$store.state.shape.containOrgShape;
        }
        get autoFormatTimes() {
            return this.$store.state.ui.autoFormatTimes;
        }
        set autoFormatTimes(data) {
            this.$store.commit("setStatus", {
                type: "autoFormatTimes",
                data,
            });
        }
        get showAutoFormatVipIcon() {
            return !this.vip; // this.autoFormatTimes >= 3 && !this.vip;
        }
        // tool function
        cancelRemind() {
            this.activeFunc = "";
        }
        undoOpe() {
            this.cancelRemind();
            if (!this.canUndo) return;
            window["_view"].undo();
            this.$track("fastTool", "undo");
        }
        redoOpe() {
            this.cancelRemind();
            if (!this.canRedo) return;
            window["_view"].redo();
            this.$track("fastTool", "redo");
        }
        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }
        rotateClick(e) {
            // 拖动选转
            let target = e.target;
            let position = target.getBoundingClientRect();
            let x0 = position.x + 11.5;
            let y0 = position.y + 11.5;
            EDOpeAssist.preUndoAction(window["_view"]._activePage, eUndo.Rotate);
            document.onmousemove = (ev) => {
                let x = ev.clientX - x0;
                let y = ev.clientY - y0;
                if (y == 0) {
                    this.rotateNum = x > 0 ? 90 : 270;
                } else if (y > 0) {
                    if (x > 0) {
                        let tan = x / y;
                        let result = Math.atan(tan) / (Math.PI / 180);
                        this.rotateNum = 180 - Math.round(result);
                    } else {
                        let tan = -x / y;
                        let result = Math.atan(tan) / (Math.PI / 180);
                        this.rotateNum = 180 + Math.round(result);
                    }
                } else if (y < 0) {
                    if (x > 0) {
                        let tan = x / -y;
                        let result = Math.atan(tan) / (Math.PI / 180);
                        this.rotateNum = Math.round(result);
                    } else {
                        let tan = -x / -y;
                        let result = Math.atan(tan) / (Math.PI / 180);
                        this.rotateNum = 360 - Math.round(result);
                    }
                }
                this.submitBoxItem("angle", this.rotateNum || 0);
            };
            document.onmouseup = () => {
                this.$track("fastTool", "toolbars", "angle");
                EDOpeAssist.addUndoAction();
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }
        checkRotateNum() {
            // 检查角度
            this.rotateNum = this.rotateNum < 0 ? 0 : this.rotateNum > 360 ? 360 : this.rotateNum;
            window["_view"].rotateShape(this.rotateNum, true);
            window["_view"].getActiveData();
        }
        get fillColorWindow() {
            return this.$store.state.ui.fillColorWindow;
        }
        showFillColor(e) {
            this.cancelRemind();
            if (!this.isSelect) return;
            if (this.fillColorWindow) {
                return;
            }
            this.sensors.track("clickEditPageButton", {
                Catalogues: "editPageButton",
                button_type: "clickFill",
            });
            // window["_view"]._tool.endEdit();
            let node = e.target;
            let payload = {
                type: this.fmtType.fill,
                index: 0,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.commit("setStatus", {
                    type: "couldFixWindow",
                    data: true,
                });
                this.$store.dispatch("usePalette", { e, type: "fillColor" });
            });
        }
        get lineColorWindow() {
            return this.$store.state.ui.lineColorWindow;
        }
        showLineColor(e) {
            this.cancelRemind();
            if (!this.isSelect) return;
            if (this.lineColorWindow) {
                return;
            }
            this.sensors.track("clickEditPageButton", {
                Catalogues: "editPageButton",
                button_type: "clickLineColor",
            });
            // window["_view"]._tool.endEdit();
            let node = e.target;
            let payload = {
                type: this.fmtType.line,
                index: 0,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.commit("setStatus", {
                    type: "couldFixWindow",
                    data: true,
                });
                this.$store.dispatch("usePalette", { e, type: "lineColor" });
            });
        }

        // 弹窗相关
        getBoxData(type) {
            // 获取弹窗初始数据
            let needDataList = ["search"]; // 需要获取数据的弹窗
            let view = window["_view"];
            let map = new Map([
                [
                    "search",
                    () => {
                        let len = view.getSearchResultCount();
                        let index = view.getCurrentSearchResultIndex();
                        this.searchResult = len > 0 ? `${index + 1}/${len}` : "0/0";
                    },
                ],
            ]);
            if (needDataList.includes(type)) map.get(type)();
        }
        setCloseListener() {
            // 设置关闭事件
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                window.addEventListener("click", this.closeBox);
            }, 0);
        }
        removeCloseListener() {
            // 移除关闭事件
            window.removeEventListener("click", this.closeBox);
        }
        closeBox(e) {
            if (this.$store.state.ui.helpTipsFlag) {
                this.removeCloseListener(); // 帮助提示下清除点击事件
                return; // 帮助提示下不关闭
            }
            if (this.lockInput) return; // 编辑状态不关闭
            let objTarget = this.$refs[this.clickBox] as HTMLElement;
            if (!objTarget || !e.target) return;
            if (objTarget != e.target && !objTarget.contains(e.target)) {
                this.expandingTool = false;
                if (this.itemList[this.clickBox]) this.itemList[this.clickBox].show = false;
                if (this.clickBox == "search") {
                    this.searchInput = "";
                    this.replaceInput = "";
                    window["_view"].clearSearchResult();
                    window.removeEventListener("keydown", this.searchEnterEvent);
                }
                this.clickBox = "";
                this.removeCloseListener();
            }
        }
        closeBoxByName(name) {
            // 关闭指定窗口
            if (name == "search") {
                if (this.lockBox) {
                    return;
                }
                this.searchInput = "";
                this.replaceInput = "";
                window["_view"].clearSearchResult();
                window.removeEventListener("keydown", this.searchEnterEvent);
            }
            if (name == "layout") {
                if (this.layoutlockBox) {
                    return;
                }
            }
            if (name == "acquiesceStyle") {
                if (this.acqlockBox) {
                    return;
                }
            }
            // if(name == 'option'){
            //     this.isSpecialFlag = 1;
            // }
            this.clickBox = "";
            this.itemList[name].show = false;
            this.expandingTool = false;
            window.removeEventListener("click", this.closeBox);
        }
        changeLock(flag) {
            this.$track("fixedbutton", "clickfixedbutton", "source: search");
            this.lockBox = flag;
        }

        quickFormatType = "first";

        handleLockAll() {
            let view = window["_view"];
            if (this.lockAllStatus) {
                view.protectChanged(-2, false);
            } else {
                view.protectChanged(-2, true);
            }
        }

        handleShowBox(type, ev) {
            if (
                ![
                    "tabsHMirror",
                    "tabsVMirror",
                    "tabsRotate",
                    "tabsMoveTop",
                    "tabsMoveBottom",
                    "tabsMoveUp",
                    "tabsMoveDown",
                    "anticClockWiseRotate",
                    "clockWiseRotate",
                ].includes(this.activeFunc)
            ) {
                this.cancelRemind();
            }
            if (type === "pageset") {
                this.trackClick("clickpageset");
                this.$bus.$emit("changeRightView", "pageset", false, "other");
                return;
            }
            if (!this.isSelect && ["layout", "mirror", "layer", "theme", "protect"].includes(type)) return;
            if (!this.isMultiSel && "align" == type) return;
            if (!(this.isSelect && (this.group || this.unGroup)) && type == "compose") return;
            if (!this.canReplaceClr && !this.canReplaceFlowClr && type == "autoFormat") return;

            switch (type) {
                case "autoFormat":
                    this.sensors.track("quickFormatting", {
                        Catalogues: "Function",
                        type: this.quickFormatType,
                    });
                    this.quickFormatType = "repeat";
                    this.trackClick("clickBeautify");
                    break;
                case "connector":
                    this.trackClick("clickConnectionLine");
                    this.backupPreview(2 - this.conType);
                    break;
                case "acquiesceStyle":
                    this.trackClick("clickLineSetting");
                    break;
                case "layer":
                    this.trackClick("clickLayer");
                    break;
                case "mirror":
                    this.trackClick("clickFlip");
                    break;
                case "compose":
                    this.trackClick("clickGroup");
                    break;
                case "protect":
                    this.trackClick("clickLock");
                    break;
                case "search":
                    this.trackClick("clickFind");
                    break;
                case "lineSize":
                    this.trackClick("clickThickness");
                    break;
                case "lineType":
                    this.trackClick("clickDash");
                    break;
                case "lineAnime":
                    // this.trackClick("clickFlowAnimitionl");
                    break;
            }
            window["_view"]._tool.endEdit();
            if (this.clickBox && ev) {
                // 关闭当前打开的窗口
                let name = this.clickBox;
                this.closeBoxByName(this.clickBox);
                if (name == type) return;
            }

            this.getBoxData(type);
            this.expandingTool = true;
            if (type == "theme" && !this.quickStyleIcons.length) {
                window["_view"].getQuickStyleList();
            }
            this.itemList[type].show = true;
            this.clickBox = type;
            this.$nextTick(() => {
                this.clickBox && this.adjustScreen();
                this.tempClickBox = type;
            });
            this.setCloseListener();
        }
        showOptionBox(type) {
            if (type === "open") {
                this.itemList["option"].show = true;
                return;
            }
            this.itemList["option"].show = !this.itemList["option"].show;
        }

        adjustScreen() {
            let target = this.$refs[`${this.clickBox}Icon`] as HTMLElement,
                alertbox = this.$refs[this.clickBox] as HTMLElement,
                boxW = alertbox.getBoundingClientRect()["width"],
                boxL = 0,
                winW = window.innerWidth,
                libW = this.$store.state.ui.sceneLeft ? 0 : 48;
            // libW = this.$store.state.ui.sceneLeft ? this.$store.state.ui.sceneLeft : 48;
            this.offsetLeft = 0;
            this.offsetTop = 0;

            if (this.hiddenToolList.includes(this.clickBox) && !this.itemList["hiddenTool"].show) {
                // 展开隐藏工具栏
                this.showToolBox();
                clearTimeout(this.showSearchTimer);
                this.showSearchTimer = setTimeout(() => {
                    target = this.$refs[`${this.clickBox}Icon`] as HTMLElement;
                    if (this.clickBox == "search") {
                        this.dragboxLeft = target.offsetLeft + 30;
                        this.dragboxTop = target.offsetTop;
                        this.$nextTick(() => {
                            (this.$refs.searchInputBox as HTMLElement).focus();
                        });
                    } else if (this.clickBox == "layout") {
                        this.draglayoutboxLeft = target.offsetLeft + 30;
                        this.draglayoutboxTop = target.offsetTop;
                    } else if (this.clickBox == "acquiesceStyle") {
                        this.dragacqboxLeft = target.offsetLeft + 30;
                        this.dragacqboxTop = target.offsetTop;
                    } else {
                        this.clickLeft = target.offsetLeft + 30;
                        this.clickTop = target.offsetTop;
                    }

                    let appendLeft = (this.$refs.appendBox as HTMLElement).getBoundingClientRect()["x"] - 0; //this.$store.state.ui.sceneLeft;
                    this.offsetLeft += appendLeft;
                    this.offsetTop += 70;
                    this.$nextTick(() => {
                        boxL = alertbox.getBoundingClientRect()["x"];
                        if (boxL + boxW > winW) {
                            this.offsetLeft -= boxW;
                        }
                    });
                }, 0);
            } else if (!this.hiddenToolList.includes(this.clickBox) && this.itemList["hiddenTool"].show) {
                // 关闭隐藏工具栏
                target = this.$refs[`${this.clickBox}Icon`] as HTMLElement;
                this.itemList["hiddenTool"].show = false;
                window.removeEventListener("click", this.closeTool);
                if (this.clickBox == "search") {
                    this.dragboxLeft = target.offsetLeft + 30;
                    this.dragboxTop = target.offsetTop;
                    this.$nextTick(() => {
                        (this.$refs.searchInputBox as HTMLElement).focus();
                    });
                } else if (this.clickBox == "layout") {
                    this.draglayoutboxLeft = target.offsetLeft + 30;
                    this.draglayoutboxTop = target.offsetTop;
                } else if (this.clickBox == "acquiesceStyle") {
                    this.dragacqboxLeft = target.offsetLeft + 30;
                    this.dragacqboxTop = target.offsetTop;
                } else {
                    this.clickLeft = target.offsetLeft + 30;
                    this.clickTop = target.offsetTop;
                }
                this.$nextTick(() => {
                    boxL = alertbox.getBoundingClientRect()["x"];
                    if (boxL + boxW > winW) {
                        this.offsetLeft -= boxW;
                    }
                });
            } else if (this.hiddenToolList.includes(this.clickBox) && this.itemList["hiddenTool"].show) {
                target = this.$refs[`${this.clickBox}Icon`] as HTMLElement;
                if (this.clickBox == "search") {
                    this.dragboxLeft = target.offsetLeft + 30;
                    this.dragboxTop = target.offsetTop;
                    this.$nextTick(() => {
                        (this.$refs.searchInputBox as HTMLElement).focus();
                    });
                } else if (this.clickBox == "layout") {
                    this.draglayoutboxLeft = target.offsetLeft + 30;
                    this.draglayoutboxTop = target.offsetTop;
                } else if (this.clickBox == "acquiesceStyle") {
                    this.dragacqboxLeft = target.offsetLeft + 30;
                    this.dragacqboxTop = target.offsetTop;
                } else {
                    this.clickLeft = target.offsetLeft + 30;
                    this.clickTop = target.offsetTop;
                }
                let appendLeft = (this.$refs.appendBox as HTMLElement).getBoundingClientRect()["x"] - 0; //this.$store.state.ui.sceneLeft;
                this.offsetLeft += appendLeft;
                this.offsetTop += 70;
                this.$nextTick(() => {
                    boxL = alertbox.getBoundingClientRect()["x"];
                    if (boxL + boxW > winW) {
                        this.offsetLeft -= boxW;
                    }
                });
            } else {
                if (this.clickBox == "search") {
                    this.dragboxLeft = target.offsetLeft + 30;
                    this.dragboxTop = target.offsetTop;
                    this.$nextTick(() => {
                        (this.$refs.searchInputBox as HTMLElement).focus();
                    });
                } else if (this.clickBox == "layout") {
                    this.draglayoutboxLeft = target.offsetLeft + 30;
                    this.draglayoutboxTop = target.offsetTop;
                } else if (this.clickBox == "acquiesceStyle") {
                    this.dragacqboxLeft = target.offsetLeft + 30;
                    this.dragacqboxTop = target.offsetTop;
                } else {
                    this.clickLeft = target.offsetLeft + 30;
                    this.clickTop = target.offsetTop;
                }
                this.$nextTick(() => {
                    boxL = alertbox.getBoundingClientRect()["x"];
                    if (boxL + boxW > winW) {
                        this.offsetLeft -= boxW;
                    }
                });
            }
        }
        clickBoxItem(type, index) {
            // 点击内部按钮 控制ui
            let keepShowList = ["align", "theme", "layout", "wiseRotation", "anticWiseRotate", "autoFormat"];
            if (type === "protect" && index !== 10) {
                keepShowList.push("protect");
            }
            let activeList = ["theme", "hiddenTool"];
            if (!keepShowList.includes(type)) {
                // 点击不消失的窗口
                this.$nextTick(() => {
                    this.closeBoxByName(type);
                });
            }
            if (type == "align") {
                window["_view"].getActiveData();
            }
            if (activeList.includes(type)) {
                // 需要高亮的窗口
                this.itemList[type]["active"] = index;
            }
            this.submitBoxItem(type, index);
            // this.cancelRemind();
        }
        clickQuickFormatType = "first";
        submitBoxItem(type, index) {
            // 提交数据到ts 实现功能
            let trackAutoFormat = (index) => {
                this.sensors.track("clickQuickFormatting", {
                    Catalogues: "Function",
                    menu_type: index == 0 ? "quick formatting" : "Replace Color",
                    type: this.clickQuickFormatType,
                });
                this.clickQuickFormatType = "repeat";
            };

            this.cancelRemind();
            let view = window["_view"];
            let tool = (view && view._tool) || null;
            let map = new Map([
                [
                    "align",
                    () => {
                        (index < 6 && (view.alignShapes(index), true)) ||
                            (index < 8 && (view.distributeShapes(index == 6 ? 0 : 4), true)) ||
                            view.flipShape(index == 8);
                    },
                ],
                [
                    "angle",
                    () => {
                        view.rotateShape(index);
                        view.getActiveData();
                    },
                ],
                [
                    "layout",
                    () => {
                        view.orderShape(index);
                    },
                ],
                [
                    "compose",
                    () => {
                        (index == 0 && (view.group(), true)) || view.unGroup();
                    },
                ],
                [
                    "protect",
                    () => {
                        (index == -1 && view.unLock()) || view.protectChanged(index);
                    },
                ],
                ["option", () => {}],
                [
                    "tool",
                    () => {
                        index == "text" && this.trackClick("clickAddText");
                        this.trackClick("clickAddText");
                        tool.endEdit();
                        tool.setType(eToolType[index]);
                        view.setActivePageData();
                    },
                ],
                [
                    "styleBrush",
                    () => {
                        this.trackClick("clickFormatPainter");
                        if (this.isSelect) {
                            this.isStyleBrushActive = !this.isStyleBrushActive;
                        }
                        view.styleBrush(this.isStyleBrushActive);
                    },
                ],
                [
                    "search",
                    () => {
                        (index == 0 && (this.search(), true)) || this.searchMove(index);
                    },
                ],
                [
                    "replace",
                    () => {
                        (index == 0 && (this.replace(), true)) || this.replaceAll();
                    },
                ],
                [
                    "connector",
                    () => {
                        this.sensors.track("clickEditPageButton", {
                            Catalogues: "editPageButton",
                            button_type: "clickConnectionLine",
                        });
                        if (this.isShowConnectorBox) {
                            // 改变线条类型
                            view.setPageConLineType(2 - index);
                            this.backupPreview(index);
                            // 创建连接线
                            tool.setType(2 + index);
                            view.setActivePageData();
                        } else if (!this.isCreateConLine) {
                            // 创建线条
                            tool.setType(2 - index + 2);
                            view.setActivePageData();
                        } else {
                            // 取消
                            tool.setType(0);
                            view.setActivePageData();
                        }
                    },
                ],
                [
                    "lineSize",
                    () => {
                        this.selectLineSize(index);
                    },
                ],
                [
                    "lineType",
                    () => {
                        this.selectLineStyle(index);
                    },
                ],
                [
                    "wiseRotation",
                    () => {
                        view.anticOrClockWiseRotate(true);
                    },
                ],
                [
                    "anticWiseRotate",
                    () => {
                        view.anticOrClockWiseRotate(false);
                    },
                ],
                [
                    "autoFormat",
                    () => {
                        trackAutoFormat(index);
                        if (index == 0) {
                            this.autoFormatTimes++;
                            // if (!this.vip && this.autoFormatTimes >= 4) {
                            //     this.$checkAuth({
                            //         type: "autoFormat",
                            //         buyTrigger: "oneClickBeautify",
                            //     });
                            //     return;
                            // }
                            checkMindmap();
                            if (this.canReplaceFlowClr) {
                                view.replaceFlowChartColor();
                                if (!this.vip) {
                                    this.sensors.track("tryVipBenefit", {
                                        Catalogues: "editFileProcess",
                                        trial_vip_benefit: "oneClickBeautify",
                                    });
                                }
                            }
                            if (this.activeRightPanelKey !== "themeP") {
                                this.$bus.$emit("changeRightViewActiveKey", "themeP");
                                this.$bus.$emit("changeRightView", "themeP", false, "other");
                            }
                            this.$bus.$emit("changeThemeAutoFormat");
                        } else {
                            this.canReplaceClr && this.showReplaceClrDialog();
                        }
                    },
                ],
            ]);
            map.get(type)();
            type != "angle" && this.$track("fastTool", "toolbars", type + "," + index);
        }
        get activeRightPanelKey() {
            return this.$store.state.ui.activeRightPanelKey;
        }
        searchDelay() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.search();
            }, 1000);
        }
        clickCheckBox(id) {
            let temp = JSON.parse(JSON.stringify(this.searchList[id]));
            this.searchList.splice(id, 1, temp);
            this.search();
        }
        search() {
            // 查找按钮
            clearTimeout(this.searchTimer);
            if (this.searchInput == "") return;
            let checkboxArr = this.searchList.map((v) => v["checked"]);
            let view = window["_view"];
            let result = view.findTextStr(this.searchInput.trim(), checkboxArr[0], checkboxArr[2], checkboxArr[1], true);

            //Result: NoResult, Finished, Failed, Successed,
            if (result === 0) {
                // let msg = this.$t('noResult');
                // this.showMessage({
                //     type: 2,
                //     content: msg
                // })
            } else {
                let index = view.getCurrentSearchResultIndex();
                view.gotoSearchResult(index);
                window.addEventListener("keydown", this.searchEnterEvent);
            }
            this.getBoxData("search"); // 获取搜索结果
        }
        searchMove(index) {
            // 移动查询指针
            let view = window["_view"];
            let sIndex = view.getCurrentSearchResultIndex();
            let sCount = view.getSearchResultCount();
            if (index === 1) {
                // 上移
                sIndex = sIndex === 0 ? sCount - 1 : sIndex - 1;
                view.gotoSearchResult(sIndex);
                console.log("上移");
            } else {
                // 下移
                sIndex = (sIndex + 1) % sCount;
                view.gotoSearchResult(sIndex);
                console.log("下移");
            }
            this.getBoxData("search"); // 获取搜索结果
        }
        replace() {
            // 替换单个
            let checkboxArr = this.searchList.map((v) => v["checked"]);
            let view = window["_view"];
            let sCount = view.getSearchResultCount();
            if (sCount) {
                view.replaceTextStr(this.replaceInput);
                this.getBoxData("search"); // 获取搜索结果
                console.log(this.replaceInput, checkboxArr);
            }
        }
        replaceAll() {
            // 替换全部
            let checkboxArr = this.searchList.map((v) => v["checked"]);
            let view = window["_view"];
            let sCount = view.getSearchResultCount();
            if (sCount) {
                view.replaceTextStr(this.replaceInput, true);
                this.getBoxData("search"); // 获取搜索结果
                console.log("替换全部");
            }
        }
        searchEnterEvent(event) {
            let key = (event as any).keyCode;
            if (key == 13) {
                // 回车
                event.preventDefault();
                this.submitBoxItem("search", 2);
            }
            if (key == 27) {
                // ESC 关闭
                this.itemList["search"].show = false;
            }
        }
        showReplaceClrDialog() {
            this.closeBoxByName("autoFormat");
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "ReplaceColor",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }

        // connect
        backupPreview(v) {
            this.connectBackup = v;
            this.$store.commit("setShapeStatus", {
                type: "conLineType",
                data: 2 - v,
            });
        }
        previewConnect(v) {
            window["_view"].setPageConLineType(2 - v, true);
        }
        recoverConnect() {
            window["_view"].setPageConLineType(2 - this.connectBackup, true);
        }

        // 默认样式
        activeDashTypeUrl(index: number = this.activeDashType) {
            // 选择第一种样式时index为0，因为index===this.activeDashType
            return "dt" + (index === 0 ? index : index - 1);
        }
        activeBeginTypeUrl(index: number = this.activeBeginType) {
            return "arrow-" + index;
        }
        activeEndTypeUrl(index: number = this.activeEndType) {
            return "arrow-" + index;
        }
        BSText(index: ArrowSize) {
            let type;
            if (index <= 3) {
                type = index + 1;
            } else if (index <= 6) {
                type = 3 * index - 6;
            } else {
                type = 14;
            }
            return ArrowSize[type];
        }
        ESText(index: ArrowSize) {
            let type;
            if (index <= 3) {
                type = index + 1;
            } else if (index <= 6) {
                type = 3 * index - 6;
            } else {
                type = 14;
            }
            return ArrowSize[type];
        }
        JPMText(n) {
            return JumpMode[n];
        }
        JPSText(n) {
            return JumpStyle[n];
        }
        ECSText(n) {
            return ElectricalCrossStyle[n];
        }
        trackClick(type) {
            this.sensors.track("clickEditPageButton", {
                Catalogues: "editPageButton",
                button_type: type,
            });
        }

        // 上传自定义箭头样式至云
        uploadTimer = 0;
        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get customPreferContent() {
            return this.$store.state.ui.customPreferContent;
        }
        set customPreferContent(v) {
            this.$store.commit("setStatus", {
                type: "customPreferContent",
                data: v,
            });
        }
        updateToCloud(obj, type?) {
            if (this.uploadTimer) {
                clearTimeout(this.uploadTimer);
            }
            this.uploadTimer = setTimeout(() => {
                let data = this.customPreferContent || {};
                Object.assign(data, obj);
                this.customPreferContent = data;
                let jsonStr = JSON.stringify(data);
                let params = {
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    obj: { content: jsonStr },
                };
                if (this.userInfo)
                    this.$edApi.updateUserPrefer(params).then((e) => {
                        console.log(e);
                    });
            }, 500);
        }
        submitToView({ type, data }) {
            let view = window["_view"];
            if (view) {
                {
                    // 其他样式沿用主题
                    // view.setUserDefaultStyle("customDefaultLineWidth", this.$store.state.ui.customDefaultLineWidth);
                    // view.setUserDefaultStyle("customDefaultBArrow", this.$store.state.ui.customDefaultBArrow);
                    // view.setUserDefaultStyle("customDefaultEArrow", this.$store.state.ui.customDefaultEArrow);
                    // view.setUserDefaultStyle("customDefaultRoundSize", this.$store.state.ui.customDefaultRoundSize);
                    // view.setUserDefaultStyle("customDefaultBSText", this.$store.state.ui.customDefaultBSText);
                    // view.setUserDefaultStyle("customDefaultESText", this.$store.state.ui.customDefaultESText);
                    // view.setUserDefaultStyle("customDefaultLineStyle", this.$store.state.ui.customDefaultLineStyle);
                    view.batchSetUserDefaultStyle({
                        customDefaultLineWidth: this.$store.state.ui.customDefaultLineWidth,
                        customDefaultBArrow: this.$store.state.ui.customDefaultBArrow,
                        customDefaultEArrow: this.$store.state.ui.customDefaultEArrow,
                        customDefaultRoundSize: this.$store.state.ui.customDefaultRoundSize,
                        customDefaultBSText: this.$store.state.ui.customDefaultBSText,
                        customDefaultESText: this.$store.state.ui.customDefaultESText,
                        customDefaultLineStyle: this.$store.state.ui.customDefaultLineStyle,
                    });
                }
                view.setUserDefaultStyle("defaultConnectorType", true);
                switch (type) {
                    case "lineW": // 线宽
                        view.setUserDefaultStyle("customDefaultLineWidth", data, true);
                        break;
                    case "BArrow": // 开始箭头样式
                        view.setUserDefaultStyle("customDefaultBArrow", data, true);
                        break;
                    case "EArrow": // 结束箭头样式
                        view.setUserDefaultStyle("customDefaultEArrow", data, true);
                        break;
                    case "round": // 圆角
                        view.setUserDefaultStyle("customDefaultRoundSize", data, true);
                        break;
                    case "BText": // 开始箭头大小
                        view.setUserDefaultStyle("customDefaultBSText", data, true);
                        break;
                    case "EText": // 结束箭头大小
                        view.setUserDefaultStyle("customDefaultESText", data, true);
                        break;
                    case "lineStyle": // 线条样式
                        view.setUserDefaultStyle("customDefaultLineStyle", data, true);
                        break;
                    case "jumpMode": // 跳点方案
                        view.setUserDefaultStyle("customDefaultJumpMode", data, true);
                        break;
                    case "jumpStyle": // 跳点样式
                        view.setUserDefaultStyle("customDefaultJumpStyle", data, true);
                        break;
                }
            }
        }
        submitToStore({ type, data }) {
            let obj = {
                type: "",
                data,
            };
            if (this.ignoreDefCnt || !this.customSet) {
                // 其他样式沿用主题
                let obj2 = {
                    type: "",
                    data,
                };
                obj2.type = "customDefaultLineWidth";
                obj2.data = this.$store.state.page.themeLineWidth;
                this.$store.commit("setStatus", obj2);

                obj2.type = "customDefaultBArrow";
                obj2.data = this.$store.state.page.themeBArrow;
                this.$store.commit("setStatus", obj2);

                obj2.type = "customDefaultEArrow";
                obj2.data = this.$store.state.page.themeEArrow;
                this.$store.commit("setStatus", obj2);

                obj2.type = "customDefaultRoundSize";
                obj2.data = this.$store.state.page.themeRoundSize;
                this.$store.commit("setStatus", obj2);

                obj2.type = "customDefaultBSText";
                obj2.data = this.$store.state.page.themeBSText;
                this.$store.commit("setStatus", obj2);

                obj2.type = "customDefaultESText";
                obj2.data = this.$store.state.page.themeESText;
                this.$store.commit("setStatus", obj2);

                obj2.type = "customDefaultLineStyle";
                obj2.data = this.$store.state.page.themeLineStyle;
                this.$store.commit("setStatus", obj2);
            }
            switch (type) {
                case "lineW": // 线宽
                    obj.type = "customDefaultLineWidth";
                    break;
                case "BArrow": // 开始箭头样式
                    obj.type = "customDefaultBArrow";
                    break;
                case "EArrow": // 结束箭头样式
                    obj.type = "customDefaultEArrow";
                    break;
                case "round": // 圆角
                    obj.type = "customDefaultRoundSize";
                    break;
                case "BText": // 开始箭头大小
                    obj.type = "customDefaultBSText";
                    break;
                case "EText": // 结束箭头大小
                    obj.type = "customDefaultESText";
                    break;
                case "lineStyle": // 线条样式
                    obj.type = "customDefaultLineStyle";
                    break;
                case "jumpMode": // 跳点方案
                    obj.type = "customDefaultJumpMode";
                    break;
                case "jumpStyle": // 跳点样式
                    obj.type = "customDefaultJumpStyle";
                    break;
            }
            this.$store.commit("setStatus", obj);
            this.$store.commit("setStatus", {
                type: "defaultConnectorType",
                data: 1,
            });
        }
        submitToCloud({ type, data }) {
            let connectorData = {
                defaultConnectorType: "1",
            };
            {
                Object.assign(connectorData, {
                    customDefaultLineWidth: this.$store.state.ui.customDefaultLineWidth,
                });
                Object.assign(connectorData, {
                    customDefaultBArrow: this.$store.state.ui.customDefaultBArrow,
                });
                Object.assign(connectorData, {
                    customDefaultEArrow: this.$store.state.ui.customDefaultEArrow,
                });
                Object.assign(connectorData, {
                    customDefaultRoundSize: this.$store.state.ui.customDefaultRoundSize,
                });
                Object.assign(connectorData, {
                    customDefaultBSText: this.$store.state.ui.customDefaultBSText,
                });
                Object.assign(connectorData, {
                    customDefaultESText: this.$store.state.ui.customDefaultESText,
                });
                Object.assign(connectorData, {
                    customDefaultLineStyle: this.$store.state.ui.customDefaultLineStyle,
                });
                this.ignoreDefCnt = false;
            }
            switch (type) {
                case "lineW": // 线宽
                    Object.assign(connectorData, {
                        customDefaultLineWidth: data,
                    });
                    break;
                case "BArrow": // 开始箭头样式
                    Object.assign(connectorData, {
                        customDefaultBArrow: data,
                    });
                    break;
                case "EArrow": // 结束箭头样式
                    Object.assign(connectorData, {
                        customDefaultEArrow: data,
                    });
                    break;
                case "round": // 圆角
                    Object.assign(connectorData, {
                        customDefaultRoundSize: data,
                    });
                    break;
                case "BText": // 开始箭头大小
                    Object.assign(connectorData, {
                        customDefaultBSText: data,
                    });
                    break;
                case "EText": // 结束箭头大小
                    Object.assign(connectorData, {
                        customDefaultESText: data,
                    });
                    break;
                case "lineStyle": // 线条样式
                    Object.assign(connectorData, {
                        customDefaultLineStyle: data,
                    });
                    break;
                case "jumpMode": // 跳点方案
                    Object.assign(connectorData, {
                        customDefaultJumpMode: data,
                    });
                    break;
                case "jumpStyle": // 线条样式
                    Object.assign(connectorData, {
                        customDefaultJumpStyle: data,
                    });
                    break;
            }
            this.updateToCloud(connectorData);
        }
        changePageConnectLine(data) {
            this.submitToStore(data);
            this.submitToView(data);
            this.submitToCloud(data);
        }

        submitToViewForLineAnimation({ type, data }) {
            let view = window["_view"];
            if (view) {
                switch (type) {
                    case "autoSetConnectorAnimation": // 默认开启
                        view.setUserDefaultStyle("customDefaultAutoSetConnectorAnimation", data);
                        break;
                    case "animeStyle": // 流动样式
                        view.setUserDefaultStyle("customDefaultAnimeStyle", data);
                        break;
                    case "animeSpeed": // 速度
                        view.setUserDefaultStyle("customDefaultAnimeSpeed", data);
                        break;
                    case "animeDensity": // 密度
                        view.setUserDefaultStyle("customDefaultAnimeDensity", data);
                        break;
                    case "animeColor": // 颜色
                        view.setUserDefaultStyle("customDefaultAnimeColor", data);
                        break;
                    case "animeDirection": // 方向
                        view.setUserDefaultStyle("customDefaultAnimeDirction", data);
                        break;
                    case "connectorAnimationShowTime": // 显示时机
                        view.setUserDefaultStyle("customDefaultConnectAnimateShowTime", data);
                        break;
                }
            }
        }
        submitToStoreForLineAnimation({ type, data }) {
            let obj = {
                type: "",
                data,
            };

            switch (type) {
                case "autoSetConnectorAnimation":
                    obj.type = "customDefaultAutoSetConnectorAnimation";
                    break;
                case "animeStyle":
                    obj.type = "customDefaultAnimeStyle";
                    break;
                case "animeSpeed":
                    obj.type = "customDefaultAnimeSpeed";
                    break;
                case "animeDensity":
                    obj.type = "customDefaultAnimeDensity";
                    break;
                case "animeColor":
                    obj.type = "customDefaultAnimeColor";
                    break;
                case "animeDirection":
                    obj.type = "customDefaultAnimeDirction";
                    break;
                case "connectorAnimationShowTime":
                    obj.type = "customDefaultConnectAnimateShowTime";
                    break;
            }
            this.$store.commit("setStatus", obj);
            return obj;
        }
        submitToCloudForLineAnimation({ type, data }) {
            let connectorAnimationData = {
                [type]: data,
            };
            this.updateToCloud(connectorAnimationData);
        }
        changePageConnectLineAnimation(data) {
            let toStoreData = this.submitToStoreForLineAnimation(data);
            this.submitToViewForLineAnimation(data);
            this.submitToCloudForLineAnimation(toStoreData);
        }

        get autoShowConnectAnimation() {
            return this.$store.state.ui.customDefaultAutoSetConnectorAnimation;
        }

        changeAutoShowConnectAnimation(val) {
            if (!this.vip && val) {
                this.$nextTick(() => {
                    this.$store.commit("setStatus", {
                        type: "customDefaultAutoSetConnectorAnimation",
                        data: !val,
                    });
                    (this.$refs.openRef as any).updateModel();
                    this.showLineAnimationFunVipTip("lineAnimationLimitCount");
                });
                return;
            }
            this.changePageConnectLineAnimation({
                type: "autoSetConnectorAnimation",
                data: val,
            });
            if (!this.showLineAnimate && val) {
                this.setAnimate(AnimeOPe.AnimeShow, Number(val));
            }
            if (!val) {
                this.trackClick("clickFlowAnimitionl");
            }
        }

        get densityPlacement() {
            if (this.lang === "de" || this.lang === "fr") {
                return "bottom-end";
            }
            return "bottom";
        }
        get directionPlacement() {
            if (this.lang === "fr" || this.lang === "pt" || this.lang === "it" || this.lang === "pt") {
                return "bottom-end";
            }
            return "bottom";
        }

        get isLine() {
            return this.$store.state.shape.isLine;
        }

        get animateShowTime() {
            return this.$store.state.ui.customDefaultConnectAnimateShowTime;
        }

        set animateShowTime(val) {
            this.changePageConnectLineAnimation({
                type: "connectorAnimationShowTime",
                data: val,
            });
            let _view = window["_view"];
            _view?.updateItemAnim();
        }

        get showLineAnimate() {
            return this.$store.state.shape.lineAnimateData.showAnime;
        }

        changeShowLineAnimate(v) {
            if (!this.vip && v) {
                let _view = window["_view"];
                let count = _view.getAnimationCount();
                if (this.isMultiSel) {
                    count += this.multiSelCount;
                } else {
                    count += 1;
                }
                if (count > 2) {
                    this.showLineAnimationFunVipTip("lineAnimationLimitCount");
                    (this.$refs.switchRef as any).currentValue = false;
                    return;
                }
            }
            this.setAnimate(AnimeOPe.AnimeShow, Number(v));
        }

        get animateStyle() {
            if (this.isSelect) {
                return this.$store.state.shape.lineAnimateData.animeStyle;
            }
            return this.$store.state.ui.customDefaultAnimeStyle;
        }

        set animateStyle(v) {
            this.setAnimate(AnimeOPe.AnimeStyle, v);
        }

        get animateSpeed() {
            if (this.isSelect) {
                return this.$store.state.shape.lineAnimateData.animeSpeed;
            }
            return this.$store.state.ui.customDefaultAnimeSpeed;
        }

        set animateSpeed(v) {
            this.setAnimate(AnimeOPe.AnimeSpeed, v);
        }

        get animateDensity() {
            if (this.isSelect) {
                return this.$store.state.shape.lineAnimateData.animeDensity;
            }
            return this.$store.state.ui.customDefaultAnimeDensity;
        }

        set animateDensity(v) {
            this.setAnimate(AnimeOPe.AnimeDensity, v);
        }

        get animateColor() {
            if (this.isSelect) {
                return this.$store.state.shape.lineAnimateData.animeColor;
            }
            return this.$store.state.ui.customDefaultAnimeColor;
        }

        get animateDirection() {
            if (this.isSelect) {
                return this.$store.state.shape.lineAnimateData.animeDirection;
            }
            return this.$store.state.ui.customDefaultAnimeDirction;
        }

        set animateDirection(v) {
            this.setAnimate(AnimeOPe.AnimeDirction, v);
        }

        showPalette(e): void {
            let payload = {
                type: this.fmtType.lineAnimate,
                index: 0,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "lineAnimateNavigation" });
                this.$store.commit("setStatus", {
                    type: "isStopPropagation",
                    data: true,
                });
            });
        }

        setAnimate(type: number, value: number | boolean) {
            let _view = window["_view"];
            if (!_view) return;
            let toStoreKey = "";
            if (!this.vip) {
                const count = _view.getAnimationCount();
                if (count === 2 && !this.showLineAnimate) {
                    this.showLineAnimationFunVipTip("lineAnimationLimitCount");
                    return;
                }
            }

            if (this.isSelect) {
                _view.animeOperation(type, value);
            }
            switch (type) {
                case AnimeOPe.AnimeShow:
                    value = !!value;
                    toStoreKey = "showAnime";
                    break;
                case AnimeOPe.AnimeStyle:
                    toStoreKey = "animeStyle";
                    break;
                case AnimeOPe.AnimeSpeed:
                    toStoreKey = "animeSpeed";
                    break;
                case AnimeOPe.AnimeDensity:
                    toStoreKey = "animeDensity";
                    break;
                case AnimeOPe.AnimeDirction:
                    toStoreKey = "animeDirection";
                    break;
            }
            if (this.isSelect && toStoreKey) {
                this.$store.commit("setLineAnimateData", {
                    type: toStoreKey,
                    data: value,
                });
            }
            if (!this.showLineAnimate && toStoreKey !== "showAnime") {
                // 不开动画的时候设置，就是改默认设置
                this.changePageConnectLineAnimation({
                    type: toStoreKey,
                    data: value,
                });
            }
            this.trackClick("clickFlowAnimitionl");
        }

        showBuyframe(type) {
            this.$openBuyPage(type);
        }
        setTypes(n, type: string) {
            let view = window["_view"];
            if (type === "style") {
                this.itemList["acquiesceStyle"][type] = n - 1;

                this.$track("fastTool", "LineDash", n - 1);
                if (this.isSelect) {
                    view.setFmt(
                        {
                            _dash: n == 1 ? n - 1 : n,
                        },
                        eFmtSetFlag.LineDash
                    );
                    view.setActiveShapeFmt();
                } else {
                    this.changePageConnectLine({
                        type: "lineStyle",
                        data: n == 1 ? n - 1 : n,
                    });
                }
            }
            // else if(type === 'Cap'){
            //     let strLiteral = n-1 === CapType.Flat? 'butt': n-1 === CapType.Square? 'square':'round'
            //     view.setFmt({
            //         _cap: strLiteral
            //     },eFmtSetFlag.LineCap)
            // }else if(type === "RP"){
            //     let rsize;
            //     if(n === 1){
            //         rsize = 0
            //     }else if(n<=6){
            //         rsize = n
            //     }else if(n === 7){
            //         rsize = 8
            //     }else{
            //         rsize = 10
            //     }
            //     this.RSize = rsize;
            //     view.setFmt({
            //         _round:rsize
            //     },eFmtSetFlag.LineRound)
            else if (type === "lineType") {
                n = 2 - (n - 1);
                view.setPageConLineType(n);
                view.setPageStatus();
            } else if (type === "jumpMode") {
                n = JumpMode[n];
                if (this.customSet) {
                    this.changePageConnectLine({
                        type: "jumpMode",
                        data: n,
                    });
                }
                view.lineJumpsModeChanged(n);
                view.setPageStatus();
            } else if (type === "jumpStyle") {
                n = JumpStyle[n];
                if (this.customSet) {
                    this.changePageConnectLine({
                        type: "jumpStyle",
                        data: n,
                    });
                }
                view.lineJumpsStyleChanged(n);
                view.setPageStatus();
            } else if (type === "electricalCrossStyle") {
                // 电路图交点样式
                n = ElectricalCrossStyle[n];
                view.setElectricalCrossStyle(n);
                view.setPageStatus();
            }

            this.itemList["acquiesceStyle"].showList = false;
            // this.$nextTick(()=>{
            //         this['show'+type+'Type'] = false;
            // })
        }

        // wall setting

        openCntTheme() {
            let ts: any = this;
            ts.$bus.$emit("changeRightViewActiveKey", "themeP");
            ts.$bus.$emit("changeRightView", "themeP", false, "other");
            this.$store.commit("setStatus", {
                type: "showThemeType",
                data: 2,
            });
            this.closeBoxByName("acquiesceStyle");
        }

        // align
        sameFuc(type) {
            switch (type) {
                case "sameWidth":
                    this.$track("fastTool", "sameWidth");
                    window["_view"].sameSize(0);
                    break;
                case "sameHeight":
                    this.$track("fastTool", "sameHeight");
                    window["_view"].sameSize(1);
                    break;
                case "sameAngle":
                    this.$track("fastTool", "sameAngle");
                    window["_view"].sameSize(2);
                    break;
                case "sameSize":
                    this.$track("fastTool", "sameSize");
                    window["_view"].sameSize(3);
                    break;
            }
        }
        setWidth() {
            this.$track("fastTool", "setWidth");
            window["_view"].setShapeSize(this.shapeWidth, "w");
            window["_view"].getActiveData();
        }
        setHeight() {
            this.$track("fastTool", "setHeight");
            window["_view"].setShapeSize(this.shapeHeight, "h");
            window["_view"].getActiveData();
        }
        setXPosition() {
            this.$track("fastTool", "setXPosition");
            window["_view"].setShapePos(this.shapeX, this.shapeY);
            window["_view"].getActiveData();
        }
        setYPosition() {
            this.$track("fastTool", "setYPosition");
            window["_view"].setShapePos(this.shapeX, this.shapeY);
            window["_view"].getActiveData();
        }
        toggleFixRatio() {
            this.$track("fastTool", "toggleFixRatio");
            this.fixRatio = !this.fixRatio;
        }

        // tool box
        showToolBox() {
            this.itemList["hiddenTool"].show = !this.itemList["hiddenTool"].show;
            if (this.itemList["hiddenTool"].show) {
                window.addEventListener("click", this.closeTool);
            } else {
                window.removeEventListener("click", this.closeTool);
            }
        }
        closeTool(e) {
            let objTarget = this.$refs["hiddenTool"] as HTMLElement;
            if (objTarget != e.target && !objTarget.contains(e.target)) {
                // if(this.clickBox != '')
                //     this.closeBoxByName(this.clickBox)
                setTimeout(() => {
                    this.itemList["hiddenTool"].show = false;
                }, 0);
                window.removeEventListener("click", this.closeTool);
            }
        }
        closeToolandChild() {
            this.itemList["hiddenTool"].show = false;
            window.removeEventListener("click", this.closeTool);
            for (let i = 0; i < this.hiddenToolList.length; i++) {
                if (this.hiddenToolList[i] === "option") {
                    continue;
                }
                this.itemList[this.hiddenToolList[i]] && this.closeBoxByName(this.hiddenToolList[i]);
            }
        }

        // others
        toggleLib() {
            this.showLibrary = !this.showLibrary;
            let ts: any = this;
            ts.$bus.$emit("toggleLibrary");
            this.$track("fastTool", "toggleLibrary", !this.showLibrary);
            this.$nextTick(() => {
                window["_view"].onsize();
            });
        }
        get specialToolStyle() {
            return {
                width: `calc(100% - ${parseFloat(this.sceneRight) + parseFloat(this.sceneLeft) + "px"})`,
                marginLeft: `${this.sceneLeft}`,
            };
        }
        get focusModeExpandRight() {
            return this.$store.getters.expandRight;
        }
        get focusModeExpandLeft() {
            return this.$store.getters.expandLeft;
        }
        get sceneRight() {
            if (!this.focusModeExpandRight) return "0";
            if (this.$store.state.ui.showRightPanel) return this.$store.state.ui.sceneRight + "px";
            else return "50px";
        }
        get sceneLeft() {
            if (!this.focusModeExpandLeft) return "0";
            return this.$store.state.ui.sceneLeft + "px";
        }
        resizeToolList() {
            // 工具条适应宽度
            if (this.toolTimer) {
                return;
            }
            this.toolTimer = true;
            if (this.clickBox) {
                this.closeBoxByName(this.clickBox);
            }
            if (this.itemList["hiddenTool"].show) {
                // 关闭工具条
                this.closeToolandChild();
            }
            setTimeout(() => {
                let windowW = window.innerWidth;

                let fontToolWidth = 654; // 包含撤销及文本工具宽度
                this.showToolList = [];
                this.hiddenToolList = [];
                // let libraryWidth = this.$store.state.ui.sceneLeft ? this.$store.state.ui.sceneLeft : 48
                let libraryWidth = this.$store.state.ui.sceneLeft ? 0 : 48;
                let width = windowW - libraryWidth - fontToolWidth;
                let tempData = JSON.parse(JSON.stringify(this.toolList));
                let minWidth = 195; // 预留空间
                let num = width - minWidth;
                let count = 0;
                let widthArr = [36, 36, 36, 36, 36, 66, 66, 12, 48, 44, 46, 12, 48, 44, 36, 36];
                while (num > 0) {
                    num -= widthArr[count];
                    count++;
                }
                this.showToolList = tempData.splice(0, count);
                this.hiddenToolList = tempData;
                if (count === 0 && width < 77) {
                    this.moreToolShow = false;
                } else {
                    this.moreToolShow = true;
                }
                this.toolTimer = false;
            }, 100);
        }

        get lockStatus() {
            return this.$store.state.ui.lockStatus;
        }

        get lockAllStatus() {
            let lockKeys = Object.keys(this.lockStatus).filter((k) => k !== "Select");
            for (let key of lockKeys) {
                if (!this.lockStatus[key]) {
                    return false;
                }
            }
            return true;
        }
        get canRotate() {
            return this.$store.state.shape.canRotate;
        }
        get banMirror() {
            return this.$store.state.shape.type == "EChartItem";
        }
        get rotateNum() {
            return (this.$store.state.shape.angle + 360) % 360;
        }
        set rotateNum(v) {
            this.$store.commit("setShapeStatus", {
                type: "angle",
                data: v - 360,
            });
        }
        get canUndo() {
            return this.$store.state.ui.canUndo;
        }
        get canRedo() {
            return this.$store.state.ui.canRedo;
        }
        get isTextEditor() {
            return this.$store.state.ui.activeToolType == 6;
        }
        // 是否创建连接线
        get isCreateConLine() {
            if (typeof eToolType === "undefined") return false;
            return ["RightAngle", "Curve", "StraightLine"].includes(eToolType[this.activeToolType]);
        }
        // 是否展示连接线下拉框
        get isShowConnectorBox() {
            return this.clickBox == "connector";
        }
        get activeToolType() {
            return this.$store.state.ui.activeToolType;
        }
        get isStyleBrush() {
            return this.$store.state.ui.activeToolType == 10;
        }
        get isMMShape() {
            return this.$store.state.shape.isMMShape;
        }
        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        // 格式刷状态
        get isStyleBrushActive() {
            return !!this.$store.state.shape.isStyleBrushActive;
        }
        set isStyleBrushActive(v) {
            this.$store.commit("setShapeStatus", { type: "isStyleBrushActive", data: v });
        }
        get isMultiSel() {
            return this.$store.state.shape.isMultiSel;
        }
        get multiSelCount() {
            return this.$store.state.shape.multiSelCount;
        }
        get group() {
            return this.$store.state.shape.group;
        }
        get unGroup() {
            return this.$store.state.shape.unGroup;
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        // get fillColorBorder() {
        //     if (window.EDCONFIG.DEFAULT_THEME === "dark") {
        //         return this.fillColor === "#1f1f1f" ? "1px solid rgba(255,255,255,0.12)" : "";
        //     }
        //     return this.fillColor === "#ffffff" ? "1px solid rgba(0,0,0,0.08)" : "";
        // }
        get fillColor() {
            return this.$store.state.shape.fillFmt.colors && this.$store.state.shape.fillFmt.colors[0];
        }
        // get lineColorBorder() {
        //     if (window.EDCONFIG.DEFAULT_THEME === "dark") {
        //         return this.lineColor === "#1f1f1f" ? "1px solid rgba(255,255,255,0.12)" : "";
        //     }
        //     return this.lineColor === "#ffffff" ? "1px solid rgba(0,0,0,0.08)" : "";
        // }
        get lineColor() {
            return this.$store.state.shape.lineFmt.colors && this.$store.state.shape.lineFmt.colors[0];
        }
        get isSwimlane() {
            return this.$store.getters.isSwimlane;
        }
        get isMatrix() {
            return this.$store.getters.isMatrix;
        }
        get isTableUnit() {
            return this.$store.getters.isTableUnit;
        }
        get isEntity() {
            return this.$store.getters.isEntity;
        }

        get isSpecial() {
            // return this.$store.getters.isSpecial
            return false;
        }
        get swimlaneLanes() {
            return this.$store.state.shape.lanes;
        }
        get swimMainTitleShow() {
            return this.$store.state.shape.swimMainTitle;
        }
        get rows() {
            return this.$store.state.shape.rows;
        }
        get columns() {
            return this.$store.state.shape.columns;
        }
        get specialColor() {
            return this.$store.state.shape.specialColor;
        }
        get showSwimBodyColor() {
            return !this.$store.state.shape.isSelectSeparator && !this.$store.state.shape.isSelectSwimTitle;
        }

        get wallThickness() {
            return this.$store.state.shape.planSet.wallThickness;
        }
        get isSelectAllMMshape() {
            return this.$store.state.shape.isAllMMShape;
        }
        get isSelectAllGanttShape() {
            return this.$store.state.shape.isAllGanttShape;
        }
        get isSelectAllTableShape() {
            return this.$store.state.shape.isAllTableShape;
        }
        set swimlaneLanes(v) {
            this.$store.commit("setShapeStatus", { type: "lanes", data: v });
        }
        set rows(v) {
            this.$store.commit("setShapeStatus", { type: "rows", data: v });
        }
        set columns(v) {
            this.$store.commit("setShapeStatus", { type: "columns", data: v });
        }

        get shapeWidth() {
            return this.$store.state.shape.width;
        }
        get shapeHeight() {
            return this.$store.state.shape.height;
        }
        get shapeX() {
            // 暂时使用宽高的值
            return this.$store.state.shape.xPos;
        }
        get shapeY() {
            return this.$store.state.shape.yPos;
        }
        get pageUnit() {
            let pageUnitList = ["mm", "cm", "m", "km", "in", "ft and in", "ft", "yd", "mi", "pt", "Pica", "Didot", "Cicero", "px"];
            return pageUnitList[this.$store.state.page.pageUnit];
        }
        set shapeX(v) {
            this.$store.commit("setShapeStatus", {
                type: "xPos",
                data: v,
            });
        }
        set shapeY(v) {
            this.$store.commit("setShapeStatus", {
                type: "yPos",
                data: v,
            });
        }
        set shapeWidth(v) {
            this.$store.commit("setShapeStatus", {
                type: "width",
                data: v,
            });
            if (this.fixRatio) {
                this.$store.commit("setShapeStatus", {
                    type: "height",
                    data: UnitUtil.pixelToUnit(window["_view"]._activeShape.height, this.pUnit + 9),
                });
            }
        }
        set shapeHeight(v) {
            this.$store.commit("setShapeStatus", {
                type: "height",
                data: v,
            });
            if (this.fixRatio) {
                this.$store.commit("setShapeStatus", {
                    type: "width",
                    data: UnitUtil.pixelToUnit(window["_view"]._activeShape.width, this.pUnit + 9),
                });
            }
        }
        get pUnit() {
            return this.$store.state.page.pageUnit;
        }

        get fixRatio() {
            return this.$store.state.shape.WHRatio;
        }
        set fixRatio(v) {
            let view = window["_view"];
            this.$store.commit("setShapeStatus", {
                type: "WHRatio",
                data: v,
            });
            view.protectChanged(2);
            view.setActiveShapeFmt();
        }
        get isActivedLine() {
            return this.$store.state.shape.isActived;
        }
        get ignoreDefCnt() {
            return this.$store.state.page.ignoreDefCnt;
        }
        set ignoreDefCnt(v) {
            let payload = {
                type: "ignoreDefCnt",
                data: v,
            };
            this.$store.commit("setPageStat", payload);
        }
        get customSet() {
            return this.$store.state.ui.defaultConnectorType == 1;
        }
        get lineWidth() {
            if (this.isSelect) return this.$store.state.shape.lineFmt.width;
            else if (this.customSet && !this.ignoreDefCnt) return this.$store.state.ui.customDefaultLineWidth;
            else return this.$store.state.page.themeLineWidth || this.$store.state.ui.defaultLineWidth;
        }
        set lineWidth(v) {
            if (this.isSelect) {
                let payload = {
                    type: "width",
                    data: v,
                };
                this.$store.commit("setLineFmtData", payload);
            } else {
                let obj = {
                    type: "customDefaultLineWidth",
                    data: v,
                };
                this.$store.commit("setStatus", obj);
            }
        }
        get roundSize() {
            if (this.isSelect) return this.$store.state.shape.lineFmt.round;
            else if (this.customSet && !this.ignoreDefCnt) return this.$store.state.ui.customDefaultRoundSize;
            else return this.$store.state.page.themeRoundSize || this.$store.state.ui.defaultRoundSize;
        }
        set roundSize(v) {
            if (this.isSelect) {
                let payload = {
                    type: "round",
                    data: v,
                };
                this.$store.commit("setLineFmtData", payload);
            } else {
                let obj = {
                    type: "customDefaultRoundSize",
                    data: v,
                };
                this.$store.commit("setStatus", obj);
            }
        }
        get activeDashType() {
            if (this.isSelect) return this.$store.state.shape.lineFmt.dash;
            else if (this.customSet && !this.ignoreDefCnt) return this.$store.state.ui.customDefaultLineStyle;
            else return this.$store.state.page.themeLineStyle || this.$store.state.ui.defaultLineStyle;
        }
        set activeDashType(v) {
            let payload = {
                type: "dash",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }
        get activeBeginType() {
            if (this.isSelect) return this.$store.state.shape.lineFmt.startArrowId;
            else if (this.customSet && !this.ignoreDefCnt) return this.$store.state.ui.customDefaultBArrow;
            else return this.$store.state.page.themeBArrow || this.$store.state.ui.defaultBArrow;
        }
        set activeBeginType(v) {
            let payload = {
                type: "startArrowId",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }
        get activeEndType() {
            if (this.isSelect) return this.$store.state.shape.lineFmt.endArrowId;
            else if (this.customSet && !this.ignoreDefCnt) return this.$store.state.ui.customDefaultEArrow;
            else return this.$store.state.page.themeEArrow || this.$store.state.ui.defaultEArrow;
        }
        set activeEndType(v) {
            let payload = {
                type: "endArrowId",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }

        get activeBSType() {
            if (this.isSelect) return this.$store.state.shape.lineFmt.startArrowSize;
            else if (this.customSet && !this.ignoreDefCnt) return this.$store.state.ui.customDefaultBSText;
            else return this.$store.state.page.themeBSText || this.$store.state.ui.defaultBSText;
        }
        set activeBSType(v) {
            let payload = {
                type: "startArrowSize",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }
        get activeESType() {
            if (this.isSelect) return this.$store.state.shape.lineFmt.endArrowSize;
            else if (this.customSet && !this.ignoreDefCnt) return this.$store.state.ui.customDefaultESText;
            else return this.$store.state.page.themeESText || this.$store.state.ui.defaultESText;
        }
        set activeESType(v) {
            let payload = {
                type: "endArrowSize",
                data: v,
            };
            this.$store.commit("setLineFmtData", payload);
        }
        get activeJPMode() {
            return this.$store.state.page.jumpMode;
        }

        get activeJPMText() {
            return JumpMode[this.activeJPMode];
        }
        get activeJPStyle() {
            return this.$store.state.page.jumpStyle;
        }

        get activeJPSText() {
            return JumpStyle[this.activeJPStyle];
        }

        get isElectrical() {
            return this.$store.state.ui.isElectrical;
        }

        get electricalCrossStyle() {
            return this.$store.state.ui.electricalCrossStyle;
        }

        set electricalCrossStyle(v) {
            this.$store.commit("setStatus", {
                type: "electricalCrossStyle",
                data: v,
            });
        }

        get activeECSText() {
            return ElectricalCrossStyle[this.electricalCrossStyle];
        }

        get showLibrary() {
            return this.$store.state.ui.showLibrary;
        }
        set showLibrary(v) {
            this.$store.commit("setStatus", {
                type: "showLibrary",
                data: v,
            });
        }
        get expandingTool() {
            return this.$store.state.ui.expandingTool;
        }
        set expandingTool(v) {
            this.$store.commit("setStatus", {
                type: "expandingTool",
                data: v,
            });
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        set activeFunc(v) {
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: v,
            });
        }
        get toolList() {
            return this.$store.state.ui.toolList;
        }
        set toolList(v) {
            this.$store.commit("setStatus", {
                type: "toolList",
                data: v,
            });
        }
        get conType() {
            if (this.isSelect && this.shapeConLine != null) return this.shapeConLine;
            else return this.$store.state.page.conLineType;
        }
        get shapeConLine() {
            return this.$store.state.shape.conLineType;
        }

        get quickStyleIcons() {
            return this.$store.state.page.quickStyleImageMap;
        }

        get canReplaceClr() {
            return this.$store.state.ui.canReplaceClr;
        }

        get canReplaceFlowClr() {
            return this.$store.state.ui.canReplaceFlowClr;
        }

        @Watch("toolList")
        watchToolList(v) {
            if (v) {
                this.resizeToolList();
            }
        }
        @Watch("searchInput")
        wacthSearchInput(nv, ov) {
            if (/.*[\u4e00-\u9fa5]+.*$/.test(nv)) {
                this.searchList[2]["checked"] = false;
                this.hasCN = true;
            } else {
                this.hasCN = false;
            }
        }

        @Watch("optionShow")
        watchOptionShow(nv, ov) {
            this.$store.commit("setStatus", {
                type: "optionShow",
                data: nv,
            });
        }
        get optionShow() {
            return this.isSpecial && this.itemList["option"].show;
        }

        get vipStateFuncList() {
            return this.$store.getters.vipStateFuncList;
        }

        showLineAnimationFunVipTip(type) {
            if (this.internal || this.lang === "zh") {
                let list = [];
                list = this.vipStateFuncList.slice();
                list.push(type);
                this.$bus.$emit("toggleFuncVipTip", { visible: true, vipFuncs: list, upgradeTrigger: "flowAnimitionllimit" });
            } else {
                this.$store.commit("toPublicStatus", {
                    type: "upgradeTrigger",
                    data: "flowAnimitionllimit",
                });
                this.$bus.$emit("togglePromodal", true, 0, 1);
            }
        }

        mounted() {
            let baseList = [
                "fontBtn",
                "connector",
                "colorFill",
                "colorline",
                "lineSize",
                "lineType",
                "lineAnime",
                "leftArrow",
                "rightArrow",
                "layer",
                "mirror", // 翻转
                "compose",
                "protect",
                "autoFormat",
                "pageset",
                "search",
            ];
            let toolbar = localStorage && localStorage.getItem("toolbar");
            this.toolList = toolbar ? JSON.parse(toolbar) : baseList;
            this.$nextTick(() => {
                this.resizeToolList();
            });
            window.addEventListener("resize", this.resizeToolList);
        }

        created() {
            let ts: any = this;
            ts.$bus.$on("openNavigationTool", (type: string) => {
                this.clickBox && this.closeBoxByName(this.clickBox);
                if (["search", "theme", "connector", "mirror", "layer", "compose", "protect", "autoFormat"].includes(type)) {
                    this.handleShowBox(type, "");
                } else if (type == "option") {
                    this.showOptionBox("open");
                }
            });
            ts.$bus.$on("openNavigationHiddenTool", (type: string) => {
                if (this.hiddenToolList.includes(type)) {
                    this.showToolBox();
                }
            });
            ts.$bus.$on("closeNavigationTool", (type: string) => {
                if (this.clickBox) this.closeBoxByName(this.clickBox);
            });
            ts.$bus.$on("toggleLibrary", () => {
                this.resizeToolList();
            });
            ts.$bus.$on("updateSearchStr", () => {
                if (this.lockBox) {
                    clearTimeout(this.searchTimer);
                    if (this.searchInput == "") return;
                    let checkboxArr = this.searchList.map((v) => v["checked"]);
                    let view = window["_view"];
                    let result = view.findTextStr(this.searchInput.trim(), checkboxArr[0], checkboxArr[2], checkboxArr[1], true);
                    this.getBoxData("search"); // 获取搜索结果
                }
            });
            ts.$bus.$on("changePageConnectLine", (data) => {
                this.changePageConnectLine(data);
            });
            ts.$bus.$on("changePageConnectLineAnimation", (data) => {
                this.changePageConnectLineAnimation(data);
            });
            this.$bus.$on("showLineFunVipTip", (data) => {
                this.showLineAnimationFunVipTip(data);
            });
        }
        beforeDestroy() {
            let ts: any = this;
            ts.$bus.$off("openNavigationTool");
            ts.$bus.$off("toggleLibrary");
            ts.$bus.$off("closeNavigationTool");
            ts.$bus.$off("updateSearchStr");
            ts.$bus.$off("changePageConnectLine");
            ts.$bus.$off("changePageConnectLineAnimation");
            ts.$bus.$off("showLineFunVipTip");
        }
    }
</script>
<i18n>
{
  "zh": {
    "Very Small": "非常小",
    "Small": "小",
    "Middle": "中",
    "Large": "大",
    "Extra Large": "特大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "None": "无",
    "Horizontal": "水平线",
    "Vertical": "垂直线",
    "Arc": "弧线",
    "Gap": "间隙",
    "Square": "正方形",
    "Point": "黑点",
    "Point2": "两面",
    "Point3": "三面",
    "mirror": "翻转",
        "hMirror": "水平翻转",
    "vMirror": "垂直翻转",
    "rotate": "旋转",
    "compose": "组合",
    "uncompose": "取消组合",
    "search": "查找",
    "replace": "替换",
    "lanes": "泳道",
    "rows": "行",
    "columns": "列",
    "showMainTitle": "显示主标题",
    "orientation": "改变方向",
    "showOrHideTitle": "显示隐藏标题",
    "textOrientation": "改变文本方向",
    "dragTitle": "查找和替换",
    "layoutTitle": "形状位置大小",
    "acqTitle": "线条样式",
    "wallTitle": "墙厚度",
    "wallCheckBox": "所有的墙壁",
    "noResult": "没有找到相应内容",
    "titleColor": "标题颜色",
    "paddingColor": "填充颜色",
    "layout": {
      "width": "宽",
      "height": "高",
      "x": "X位置",
      "y": "Y位置"
    },
    "connectorList": {
      "linkLine1": "直角连接线",
      "linkLine2": "曲线连接线",
      "linkLine3": "直线连接线"
    },
    "tipsList": {
        "toggleLib": "显示符号库",
        "undo": "撤销",
        "redo": "重做",
        "format": "格式刷",
        "text": "添加文本   Ctrl+2",
        "textAlign": "布局、对齐、等宽高",
        "layout": "位置、宽高、角度",
        "fixRatio": "锁定纵横比",
        "layer": "层级",
        "fillColor": "填充颜色",
        "lineColor": "线条颜色",
        "compose": "组合",
        "search": "查找",
        "protect": "锁定",
        "unprotect": "解除锁定",
        "option": "特殊设置",
        "acquiesceStyle": "线条样式",
        "theme": "快速样式",
        "pageset": "页面设置",
        "connector": "连接线",
        "new-layer1": "置于顶层",
        "new-layer2": "置于底层",
        "new-layer3": "上移一层",
        "new-layer4": "下移一层",
        "align01": "左对齐",
        "align02": "居中对齐",
        "align03": "右对齐",
        "align04": "顶部对齐",
        "align05": "居中对齐",
        "align06": "底部对齐",
        "align07": "水平等间距",
        "align08": "垂直等间距",
        "sameWidth": "等宽",
        "sameHeight": "等高",
        "sameAngle": "等角度",
        "sameSize": "等大小",
        "replace": "替换",
        "replaceAll": "替换全部",
        "styleBrush": "格式刷",
        "leftArrow": "起点",
        "rightArrow": "终点",
        "arrowSize": "箭头大小",
        "lineSize": "粗细",
        "lineType": "虚线",
        "otherWeight": "其他粗细"
    },
    "openanimate": "开启流向动画",
    "lineanimate": "流向动画",
    "deafultopen": "默认开启",
    "styleset": "样式设置",
    "anistyle": "流动样式",
    "anispeed": "流动速度",
    "anidensity": "流动密度",
    "anicolor": "动画颜色",
    "anidirection": "动画方向",
    "aniarrow": "箭头",
    "anicircle": "圆点",
    "anifast": "快速",
    "animedium": "中等",
    "anislow": "慢速",
    "anilarge": "密集",
    "anifew": "稀疏",
    "aniforward": "正向",
    "anireverse": "反向",
    "showtime": "显示时机",
    "openshow": "开启即显示",
    "clickshow": "点击图形显示",
    "limit2lines": "限免2条。",
    "tovip": "开通VIP尊享无限使用",
    "protectList": {
      "width": "宽度",
      "height": "高度",
      "ratio": "横纵比",
      "horizontal": "X轴位置",
      "vertical": "Y轴位置",
      "rotate": "旋转",
      "begin": "起点",
      "end": "终点",
      "group": "阻止取消组合",
      "text": "文本",
      "select": "阻止选择",
      "delete": "阻止删除",
      "link": "阻止连接",
      "format": "样式",
      "groupFormat": "阻止应用组合样式",
      "groupFill": "组合填充",
      "theme": "阻止应用主题",
      "snapOutline": "连接轮廓",
      "unlock": "解锁全部"
    },
    "searchList": {
      "caseSensitive": "区分大小写",
      "allPage": "所有页面",
      "fullMatch": "全字匹配"
    },
    "acquiesceStyleBox": {
      "lineStyle": "线条样式",
      "lineWidth": "线条宽度",
      "arrowStyle": "箭头样式",
      "arrowSize": "箭头大小",
      "radiusSize": "圆角大小",
      "connectorStyle": "连接线样式",
      "connectorPoint": "跳点方案",
      "connectorPointStyle": "跳点样式",
      "electricalCrossStyle": "电路图交点样式",
      "defaultPointerStyle": "设置默认连接线主题"
    },
    "optionbox-headColor": "顶部颜色",
    "optionbox-bodyColor": "泳道颜色",
    "optionbox-borderColor": "边框颜色",
    "swimMainTitle": {
      "None": "无",
      "Top": "顶部",
      "Left": "左部"
    },
    "autoFormatList": {
      "autoFormatting": "一键美化",
      "ReplaceClr": "批量替换颜色"
    }
  },
  "en": {
    "Very Small": "Very Small",
    "Small": "Small",
    "Middle": "Middle",
    "Large": "Large",
    "Extra Large": "Extra Large",
    "Jumbo": "Jumbo",
    "Colossal": "Colossal",
    "None": "None",
    "Horizontal": "Horizontal",
    "Vertical": "Vertical",
    "Arc": "Arc",
    "Gap": "Gap",
    "Square": "Square",
    "Point": "Point",
    "Point2": "Two Sides",
    "Point3": "Three Sides",
    "mirror": "Flip",
    "hMirror": "Horizontally",
    "vMirror": "Vertically",
    "rotate": "Rotate",
    "compose": "Group",
    "uncompose": "Ungroup",
    "search": "Search",
    "replace": "Replace",
    "lanes": "Lanes",
    "rows": "Rows",
    "columns": "Columns",
    "showMainTitle": "Display the main title ",
    "orientation": "Change Orientation",
    "showOrHideTitle": "Show/Hide Title",
    "textOrientation": "Change Text Orientation",
    "dragTitle": "Find & Replace",
    "layoutTitle": "Position & Size",
    "acqTitle": "Line Style",
    "wallTitle": "Wall Thickness",
    "wallCheckBox": "All Walls",
    "noResult": "No Result",
    "titleColor": "Title Color",
    "paddingColor": "Body Color",
    "layout": {
      "width": "Width",
      "height": "Height",
      "x": "X Position",
      "y": "Y Position"
    },
    "connectorList": {
      "linkLine1": "Elbow Connector",
      "linkLine2": "Curved Connector",
      "linkLine3": "Straight Connector"
    },
    "tipsList": {
      "toggleLib": "Show Symbol Library",
      "undo": "Undo",
      "redo": "Redo",
      "format": "Format Painter",
      "text": "Add Text Ctrl+2",
      "textAlign": "Layout, Alignment, Aspect Ratio",
      "layout": "Position, Width, Height, Angle",
      "fixRatio": "Lock aspect ratio",
      "layer": "Layer",
      "fillColor": "Fill Color",
      "lineColor": "Line Color",
      "compose": "Group",
      "search": "Find",
      "protect": "Locked",
      "unprotect": "UnLock",
      "option": "Exceptional Settings",
      "acquiesceStyle": "Line Style",
      "theme": "Quick Style",
      "pageset": "Page Settings",
      "connector": "Connector",
      "new-layer1": "To front",
    "new-layer2": "To Back",
    "new-layer3": "Forward",
    "new-layer4": "Backward",
      "align01": "Align Left",
      "align02": "Align Center",
      "align03": "Align Right",
      "align04": "Align Top ",
      "align05": "Align Middle ",
      "align06": "Align Bottom ",
      "align07": "Distribute Horizontally",
      "align08": "Distribute Vertically",
      "sameWidth": "Same Width",
      "sameHeight": "Same Height",
      "sameAngle": "Same Angle",
      "sameSize": "Same Size",
      "replace": "Replace",
      "replaceAll": "Replace All",
      "styleBrush": "Format Painter",
      "leftArrow": "Start",
      "rightArrow": "End",
      "arrowSize": "Arrow size",
      "lineSize": "Line Weight",
        "lineType": "Line Type",
        "otherWeight": "More Lineweights"
    },
    "openanimate": "Enable Flow Animation",
        "lineanimate": "Flow Animation",
        "deafultopen": "Enabled by default",
        "styleset": "Style Settings",
        "anistyle": "Flow style",
        "anispeed": "Flow speed",
        "anidensity": "Flow density",
        "anicolor": "Flow color",
        "anidirection": "Flow direction",
        "aniarrow": "Arrows",
        "anicircle": "Beads",
        "anifast": "Fast",
        "animedium": "Medium",
        "anislow": "Slow",
        "anilarge": "Dense",
        "anifew": "Sparse",
        "aniforward": "Forward",
        "anireverse": "Reverse",
        "showtime": "Flow Timing",
        "openshow": "Display when enabled",
        "clickshow": "Display when clicking shapes",
        "limit2lines": "Limited to 2 lines. ",
        "tovip": "Upgrade to Premium for unlimited Flow Animations.",
    "protectList": {
      "width": "Width",
      "height": "Height",
      "ratio": "Aspect Ratio",
      "horizontal": "X Position",
      "vertical": "Y Position",
      "rotate": "Rotation",
      "begin": "Begin Point",
      "end": "End Point",
      "group": "Ungroup",
      "text": "Edit Text",
      "select": "From Selection",
      "delete": "From Deletion",
      "link": "From Connection",
      "format": "Format",
      "groupFormat": "From Group Formatting",
      "groupFill": "From Group Filling",
      "theme": "Theme",
      "snapOutline": "From Snapping to Outline",
      "unlock": "UnLock All"
    },
    "searchList": {
      "caseSensitive": "Case Sensitive",
      "allPage": "All Pages",
      "fullMatch": "Find whole words only"
    },
    "acquiesceStyleBox": {
      "lineStyle": "Line Type",
      "lineWidth": "Line Width",
      "arrowStyle": "Arrow Style",
      "arrowSize": "Arrow Size",
      "radiusSize": "Rounding Size",
      "connectorStyle": "Connector Style",
      "connectorPoint": "Jump Direction",
      "connectorPointStyle": "Jump Style",
      "electricalCrossStyle": "Wire connection setting",
      "defaultPointerStyle": "Default Connector Style"
    },
    "optionbox-headColor": "Top Color",
    "optionbox-bodyColor": "Swim Lane Color",
    "optionbox-borderColor": "Border Color",
    "swimMainTitle": {
      "None": "None",
      "Top": "Top",
      "Left": "Left"
    },
    "autoFormatList": {
      "autoFormatting": "Auto Formatting",
      "ReplaceClr": "Batch Replace Color"
    }
  },
  "fr": {
    "Very Small": "Très petit",
    "Small": "Petit ",
    "Middle": "Moyen",
    "Large": "Grand",
    "Extra Large": "Très Grand",
    "Jumbo": "Géant",
    "Colossal": "Colossal",
    "None": "Aucun",
    "Horizontal": "Horizontal",
    "Vertical": "Vertical",
    "Arc": "Arc",
    "Gap": "Écart",
    "Square": "Carrée",
    "Point2": "Deux Côtés",
    "Point3": "Trois Côtés",
    "mirror": "Pivoter",
    "hMirror": "Horizontal",
    "vMirror": "Vertical",
    "rotate": "Rotation",
    "compose": "Groupe ",
    "uncompose": "Dissocier",
    "search": "Recherche",
    "replace": "Remplacer",
    "lanes": "Couloir de nage",
    "showMainTitle": "Afficher le titre principal",
    "rows": "Lignes",
    "columns": "Colonnes",
    "orientation": "Changer l'orientation",
    "showOrHideTitle": "Afficher le titre caché",
    "textOrientation": "Modifier l'orientation du texte",
    "dragTitle": "Rechercher et remplacer",
    "layoutTitle": "position et taille",
    "acqTitle": "Style de ligne",
    "wallTitle": "Epaisseur de paroi",
    "wallCheckBox": "Tous les murs",
    "noResult": "Aucun contenu correspondant n'a été trouvé",
    "titleColor": "Couleur du titre",
    "paddingColor": "Couleur de corps",
    "layout": {
      "width": "Largeur",
      "height": "Haut",
      "x": "Position X",
      "y": "Position Y"
    },
    "connectorList": {
      "linkLine1": "Connecteur Coudé",
      "linkLine2": "Connecteur Courbe",
      "linkLine3": "Connecteur Droit"
    },
    "tipsList": {
      "toggleLib": "Afficher Bibliothèque de Symboles",
      "undo": "Annuler",
      "redo": "Refaire",
      "format": "Format Brosse",
      "text": "Texte",
      "textAlign": "Alignement",
      "layout": "Attribut",
      "fixRatio": "Verrouiller le rapport hauteur / largeur",
      "layer": "Superposer",
      "fillColor": "Couleur de remplissage",
      "lineColor": "Couleur du trait",
      "compose": "Grouper",
      "search": "Rechercher",
      "protect": "Protéger",
      "unprotect": "Débloquer",
      "option": "Paramètres spéciaux",
      "acquiesceStyle": "Style de ligne",
      "theme": "Style rapide",
      "pageset": "Paramètres de Page",
      "connector": "Ligne de connexion",
      "new-layer1": "Vers l'avant",
    "new-layer2": "Vers l'arrière",
    "new-layer3": "Avance",
    "new-layer4": "Retour",
      "align01": "Aligner à gauche",
      "align02": "Aligner au centre",
      "align03": "Aligner à Droit",
      "align04": "Aligner en haut",
      "align05": "Aligner au centre",
      "align06": "Aligner en bas ",
      "align07": "À égale distance horizontale",
      "align08": "À égale distance verticale",
      "sameWidth": "Même largeur",
      "sameHeight": "Même hauteur ",
      "sameAngle": "Même angle",
      "sameSize": "Même angle",
      "replace": "Remplacer",
      "replaceAll": "Tout remplacer ",
      "styleBrush": "Pinceau de format",
      "leftArrow": "Début",
      "rightArrow": "Fin",
      "arrowSize": "Taille de la flèche",
      "lineSize": "Epaisseur de la ligne",
        "lineType": "Type de ligne",
        "otherWeight": "Plus d'épaisseurs de ligne"
    },
    "openanimate": "Activer Animation du flux",
        "lineanimate": "Animation du flux",
        "deafultopen": "Activé par défaut",
        "styleset": "Paramètres de style",
        "anistyle": "Type de flux",
        "anispeed": "Vitesse du flux ",
        "anidensity": "Densité du flux ",
        "anicolor": "Couleur du flux",
        "anidirection": "Direction du flux ",
        "aniarrow": "Flèches",
        "anicircle": "Puces",
        "anifast": "Rapide",
        "animedium": "Moyenne",
        "anislow": "Lente",
        "anilarge": "Dense",
        "anifew": "Peu dense",
        "aniforward": "Vers l'avant",
        "anireverse": "Inversion",
        "showtime": "Durée du flux",
        "openshow": "S'affiche lorsque cette option est activée",
        "clickshow": "S'affiche lorsque l'on clique sur les formes",
        "limit2lines": "Limité à deux lignes.",
        "tovip": "Passez à la version Premium pour bénéficier d'un nombre illimité d'animations du flux.",
    "protectList": {
      "width": "Largeur",
      "height": "Hauteur",
      "ratio": "Aspect Ratio",
      "horizontal": "Position horizontale",
      "vertical": "Position verticale",
      "rotate": "Rotation",
      "begin": "Point de départ",
      "end": "Terminer",
      "group": "Dissocier",
      "text": "Modifier le texte",
      "select": "Protéger sélectionné",
      "delete": "Protéger Supprimé",
      "link": "Bloquer la connexion",
      "format": "Format",
      "groupFormat": "Protéger format combiné",
      "groupFill": "Protéger combinaison de remplissage",
      "theme": "Protéger thème",
      "snapOutline": "Contour de connexion",
      "unlock": "Tout déverrouiller"
    },
    "searchList": {
      "caseSensitive": "Sensible aux majuscules et minuscules",
      "allPage": "Toutes les pages",
      "fullMatch": "Trouver des mots entiers uniquement"
    },
    "acquiesceStyleBox": {
      "lineStyle": "Style de ligne",
      "lineWidth": "Largeur de ligne",
      "arrowStyle": "Style de flèche",
      "arrowSize": "Taille de la flèche",
      "radiusSize": "Taille du filet",
      "connectorStyle": "Style de connecteur",
      "connectorPoint": "Direction du saut",
      "connectorPointStyle": "Style de saut",
      "defaultPointerStyle": "Style de connecteur par défaut"
    },
    "optionbox-headColor": "Couleur du haut",
    "optionbox-bodyColor": "Couleur de voie",
    "optionbox-borderColor": "Couleur de la bordure",
    "swimMainTitle": {
      "None": "Rien",
      "Top": "Haut",
      "Left": "La gauche"
    },
    "autoFormatList": {
      "autoFormatting": "Formatage automatique",
      "ReplaceClr": "Remplacement de la couleur par lot"
    }
  },
  "de": {
    "Very Small": "Sehr klein",
    "Small": "Klein",
    "Middle": "Mittel",
    "Large": "Groß",
    "Extra Large": "Sehr groß",
    "Jumbo": "Jumbo",
    "Colossal": "Kolossal",
    "None": "Nichts",
    "Horizontal": "Horizontale Linie",
    "Vertical": "Vertikale Linie",
    "Arc": "Bogen",
    "Gap": "Abstand",
    "Square": "Quadrat",
    "Point2": "Zweiseitig",
    "Point3": "Dreiseitig",
    "mirror": "Spiegeln",
    "hMirror": "Horizontal",
    "vMirror": "Vertikal",
    "rotate": "Drehung",
    "compose": "Kombination",
    "uncompose": "Kombination auflösen",
    "search": "Suchen",
    "replace": "Ersetzen",
    "lanes": "Wege",
    "showMainTitle": "Haupttitel anzeigen",
    "rows": "Zeile",
    "columns": "Spalte",
    "orientation": "Einrichtung",
    "showOrHideTitle": "Titel zeigen/verbergen",
    "textOrientation": "Texteinrichtung ändern",
    "dragTitle": "Suchen & Ersetzen",
    "layoutTitle": "Position & Größe",
    "acqTitle": "Linienstil",
    "wallTitle": "Wandbreite",
    "wallCheckBox": "Alle Wände",
    "noResult": "Kein Ergebnis",
    "titleColor": "Titelfarbe",
    "paddingColor": "Körperfarbe",
    "layout": {
      "width": "Breite",
      "height": "Größe",
      "x": "X Position",
      "y": "Y Position"
    },
    "connectorList": {
      "linkLine1": "Ellenbogen-Verbinder",
      "linkLine2": "Kurven-Verbinder",
      "linkLine3": "Gerader Verbinder"
    },
    "tipsList": {
      "toggleLib": "Symbol Bibliothek anzeigen",
      "undo": "Rückgängig machen",
      "redo": "Wiederherstellen",
      "format": "Format",
      "text": "Text",
      "textAlign": "Ausrichten",
      "layout": "Eigenschaft",
      "fixRatio": "Seitenverhältnis sperren",
      "layer": "Ebene",
      "fillColor": "Farbe eingeben",
      "lineColor": "Liniensfarbe",
      "compose": "Gruppieren",
      "search": "Suchen",
      "protect": "Schützen",
      "unprotect": "Entsperren",
      "option": "Ausserordentliche Einstellungen",
      "acquiesceStyle": "Linien Style",
      "theme": "Quick Style",
      "pageset": "Seiteneinstellung",
      "connector": "Verbindung",
      "new-layer1": "Nach vorne",
    "new-layer2": "Nach hinten",
    "new-layer3": "Vor",
    "new-layer4": "Zurück",
      "align01": "Linksbündig",
      "align02": "Zentriert ",
      "align03": "Rechtsbündig",
      "align04": "Obenbündig",
      "align05": "Mittebündig",
      "align06": "untenbündig",
      "align07": "Horizontaler Abstand",
      "align08": "Vertikaler Abstand",
      "sameWidth": "Gleiche Breite",
      "sameHeight": "Gleiche Höhe",
      "sameAngle": "Gleicher Winkel",
      "sameSize": "Gleiche Größe",
      "replace": "Ersetzen",
      "replaceAll": "Alles ersetzen",
      "styleBrush": "Stil Pinsel",
      "leftArrow": "Startpunkt",
      "rightArrow": "Endpunkt",
      "arrowSize": "Pfeilgröße",
      "lineSize": "Linienstärke",
        "lineType": "Linientyp",
        "otherWeight": "Weitere Linienstärken"
    },
    "openanimate": "Flussanimation aktivieren",
        "lineanimate": "Flüssige Animation",
        "deafultopen": "Standardmäßig aktiviert",
        "styleset": "Stileinstellungen",
        "anistyle": "Fluss-Stil",
        "anispeed": "Flussgeschwindigkeit",
        "anidensity": "Flussdichte",
        "anicolor": "Flussfarbe",
        "anidirection": "Flussrichtung",
        "aniarrow": "Pfeile",
        "anicircle": "Punkte",
        "anifast": "Schnell",
        "animedium": "Mittel",
        "anislow": "Langsam",
        "anilarge": "Dicht",
        "anifew": "Dünn besetzt",
        "aniforward": "Vor",
        "anireverse": "Zurück",
        "showtime": "Zeitpunkt des Flusses",
        "openshow": "Anzeigen, wenn aktiviert",
        "clickshow": "Anzeigen beim Klicken auf Formen",
        "limit2lines": "Auf 2 Zeilen beschränkt.",
        "tovip": "Upgrade auf Premium für unbegrenzte Flussanimationen.",
    "protectList": {
      "width": "Breite",
      "height": "Höhe",
      "ratio": "Seitenverhältnis",
      "horizontal": "Horizontal",
      "vertical": "Vertikal",
      "rotate": "Drehen",
      "begin": "Anfangspunkt",
      "end": "Abschlusspunkt",
      "group": "Gruppieren löschen",
      "text": "Text bearbeiten",
      "select": "Ausgwählte schützen",
      "delete": "Gelöschte schützen",
      "link": "Verbinden verhindern",
      "format": "Format",
      "groupFormat": "Gruppenformat schützen",
      "groupFill": "Gruppefüllen schützen",
      "theme": "Thema schützen",
      "snapOutline": "Outline verbinden ",
      "unlock": "Alles entsperren"
    },
    "searchList": {
      "caseSensitive": "Groß- und Kleinschreibung beachten",
      "allPage": "Alle Seite ",
      "fullMatch": "Vollständige Wortübereinstimmung"
    },
    "acquiesceStyleBox": {
      "lineStyle": "Linien Art",
      "lineWidth": "Linien Breite",
      "arrowStyle": "Pfeilsart",
      "arrowSize": "Pfeilsgröße",
      "radiusSize": "Größe der Rundecke",
      "connectorStyle": "Verbindersart",
      "connectorPoint": "Sprungrichtung",
      "connectorPointStyle": "Sprungstyle",
      "defaultPointerStyle": "Standard Verbinderstyle"
    },
    "optionbox-headColor": "Kopffarbe",
    "optionbox-bodyColor": "Swimlanefarbe",
    "optionbox-borderColor": "Randfarbe",
    "swimMainTitle": {
      "None": "Nichts",
      "Top": "Hoch",
      "Left": "Links"
    },
    "autoFormatList": {
      "autoFormatting": "Automatisch formatieren",
      "ReplaceClr": "Farbe stapelweise ersetzen"
    }
  },
  "jp": {
    "Very Small": "極小",
    "Small": "小",
    "Middle": "中",
    "Large": "大",
    "Extra Large": "極大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "None": "なし",
    "Horizontal": "水平線",
    "Vertical": "垂直線",
    "Arc": "弧線",
    "Gap": "ギャップ",
    "Square": "正方形",
    "Point2": "三角形",
    "Point3": "台形",
    "mirror": "反転",
    "hMirror": "水平",
    "vMirror": "垂直",
    "rotate": "回転",
    "compose": "グループ化",
    "uncompose": "グループ化解除",
    "search": "検索",
    "replace": "置換",
    "lanes": "レーン",
    "showMainTitle": "メインタイトルを表示",
    "rows": "行",
    "columns": "列",
    "orientation": "向きを変更",
    "showOrHideTitle": "タイトルを表示",
    "textOrientation": "テキストの向きを変更",
    "dragTitle": "検索と置換",
    "layoutTitle": "位置 & サイズ",
    "acqTitle": "線のスタイル",
    "wallTitle": "壁の厚さ",
    "wallCheckBox": "すべての壁の厚さ",
    "noResult": "コンテンツが見つかりません",
    "titleColor": "タイトルの色",
    "paddingColor": "スイムレーンの色",
    "layout": {
      "width": "幅を設定",
      "height": "高さを設定",
      "x": "Xを設定",
      "y": "Yを設定"
    },
    "connectorList": {
      "linkLine1": "直角コネクター",
      "linkLine2": "曲線コネクター",
      "linkLine3": "直線コネクター"
    },
    "tipsList": {
      "toggleLib": "図形ライブラリを表示",
      "undo": "元に戻す",
      "redo": "やり直し",
      "format": "書式のコピーと貼り付け",
      "text": "テキスト",
      "textAlign": "テキストの揃え方",
      "layout": "レイアウト",
      "fixRatio": "アスペクト比のロック",
      "layer": "レイヤー",
      "fillColor": "塗りつぶし",
      "lineColor": "線の色",
      "compose": "グループ化",
      "search": "検索",
      "protect": "ロック",
      "unprotect": "ロック解除",
      "option": "特別な設定",
      "acquiesceStyle": "線のスタイル",
      "theme": "クイック書式",
      "pageset": "ページ設定",
      "connector": "コネクター",
      "new-layer1": "正面",
    "new-layer2": "背面",
    "new-layer3": "前方",
    "new-layer4": "後方",
      "align01": "左揃え",
      "align02": "中央揃え",
      "align03": "右揃え",
      "align04": "上揃え",
      "align05": "中央揃え",
      "align06": "下揃え",
      "align07": "水平方向等間隔",
      "align08": "垂直方向等間隔",
      "sameWidth": "等幅",
      "sameHeight": "等高",
      "sameAngle": "等角",
      "sameSize": "等サイズ",
      "replace": "置換",
      "replaceAll": "すべてを置換",
      "styleBrush": "書式のコピー／貼り付け",
      "leftArrow": "出発点",
      "rightArrow": "終点",
      "arrowSize": "矢印サイズ",
      "lineSize": "太さ",
        "lineType": "線種",
        "otherWeight": "その他の線"
    },
    "openanimate": "フローアニメーションを有効にする",
        "lineanimate": "フローアニメーション",
        "deafultopen": "デフォルトで有効にする",
        "styleset": "スタイル設定",
        "anistyle": "フロースタイル",
        "anispeed": "フローの速さ",
        "anidensity": "フローの密度",
        "anicolor": "フローの色",
        "anidirection": "フローの方向",
        "aniarrow": "矢印",
        "anicircle": "ビーズ",
        "anifast": "速",
        "animedium": "中",
        "anislow": "遅",
        "anilarge": "密",
        "anifew": "疎",
        "aniforward": "順方向",
        "anireverse": "逆方向",
        "showtime": "フローのタイミング",
        "openshow": "有効にしたときに表示",
        "clickshow": "図形をクリックしたときに表示",
        "limit2lines": "2本の線までに制限されています。",
        "tovip": "プレミアムにアップグレードして、フローアニメーションを無制限に作成しましょう。",
    "protectList": {
      "width": "幅",
      "height": "高さ",
      "ratio": "縦横比",
      "horizontal": "水平位置",
      "vertical": "垂直位置",
      "rotate": "回転",
      "begin": "始点",
      "end": "終点",
      "group": "グループ化解除",
      "text": "テキストを編集",
      "select": "選択したもの",
      "delete": "削除しないまま",
      "link": "接続しないまま",
      "format": "書式",
      "groupFormat": "グループの書式",
      "groupFill": "グループの塗りつぶし",
      "theme": "テーマ",
      "snapOutline": "アウトラインにスナップ",
      "unlock": "すべてのロックを解除"
    },
    "searchList": {
      "caseSensitive": "大文字と小文字を区別する",
      "allPage": "すべてのページ",
      "fullMatch": "完全に一致する単語だけを検索する"
    },
    "acquiesceStyleBox": {
      "lineStyle": "線のスタイル",
      "lineWidth": "線の太さ",
      "arrowStyle": "矢印スタイル",
      "arrowSize": "矢印サイズ",
      "radiusSize": "曲がり角度",
      "connectorStyle": "コネクターのスタイル",
      "connectorPoint": "接続交差点の方向",
      "connectorPointStyle": "接続交差点のスタイル",
      "defaultPointerStyle": "コネクターのデフォルトテーマ"
    },
    "optionbox-headColor": "ボックスヘッドの色",
    "optionbox-bodyColor": "レーンの色",
    "optionbox-borderColor": "ボーダの色",
    "swimMainTitle": {
      "None": "なし",
      "Top": "上",
      "Left": "左"
    },
    "autoFormatList": {
      "autoFormatting": "自動フォーマット",
      "ReplaceClr": "色の一括置換"
    }
  },
  "es": {
    "Very Small": "Muy pequeño",
    "Small": "Pequeño",
    "Middle": "Medio",
    "Large": "Gran",
    "Extra Large": "Extra grande",
    "Jumbo": "Jumbo",
    "Colossal": "Colosal",
    "None": "Ninguno",
    "Horizontal": "Horizontal",
    "Vertical": "Vertical",
    "Arc": "Arco",
    "Gap": "Brecha",
    "Square": "Cuadrado",
    "Point2": "Dos lados",
    "Point3": "Tres lados",
    "mirror": "Girar",
    "hMirror": "En horizontal",
    "vMirror": "En vertical",
    "rotate": "Girar",
    "compose": "Grupo",
    "uncompose": "Desagrupar",
    "search": "Buscar",
    "replace": "Reemplazar",
    "lanes": "Líneas",
    "showMainTitle": "Mostrar título principal",
    "rows": "Filas",
    "columns": "Columnas",
    "orientation": "Cambiar la orientación",
    "showOrHideTitle": "Mostrar/ocultar el título",
    "textOrientation": "Cambiar la orientación del texto",
    "dragTitle": "Buscar y reemplazar",
    "layoutTitle": "posición y tamaño",
    "acqTitle": "Estilo de línea",
    "wallTitle": "Espesor de la pared",
    "wallCheckBox": "Todas las paredes",
    "noResult": "No hay resultados",
    "titleColor": "Color del título",
    "paddingColor": "Color del cuerpo",
    "layout": {
      "width": "Ancho",
      "height": "Altura",
      "x": "Posición X",
      "y": "Posición Y"
    },
    "connectorList": {
      "linkLine1": "Conector del codo",
      "linkLine2": "Conector curvo",
      "linkLine3": "Conector recto"
    },
    "tipsList": {
      "toggleLib": "Mostrar Biblioteca de símbolos",
      "undo": "Deshacer",
      "redo": "Rehacer",
      "format": "Pintor de Formatos",
      "text": "Añadir texto Ctrl+2",
      "textAlign": "Disposición, alineación, relación de aspecto",
      "layout": "Posición, anchura, altura, ángulo",
      "fixRatio": "Bloquee la relación de aspecto",
      "layer": "Capa",
      "fillColor": "Color de relleno",
      "lineColor": "Color de línea",
      "compose": "Grupo",
      "search": "Encuentra",
      "protect": "Proteger",
      "unprotect": "Desbloquear",
      "option": "Ajustes excepcionales",
      "acquiesceStyle": "Estilo de línea",
      "theme": "Estilo rápido",
      "pageset": "Configuración de la página",
      "connector": "Conector",
      "new-layer1": "Hacia delante",
    "new-layer2": "Hacia atrás",
    "new-layer3": "Avanzar",
    "new-layer4": "Retroceder",
      "align01": "Alinear a la izquierda",
      "align02": "Alinear el centro",
      "align03": "Alinear a la derecha",
      "align04": "Alinear la parte superior ",
      "align05": "Alinear el medio ",
      "align06": "Alinear el fondo ",
      "align07": "Distribuir horizontalmente",
      "align08": "Distribuir verticalmente",
      "sameWidth": "Mismo ancho",
      "sameHeight": "Misma altura",
      "sameAngle": "Mismo ángulo",
      "sameSize": "Mismo tamaño",
      "replace": "Reemplazar",
      "replaceAll": "Reemplazar todo",
      "styleBrush": "Pincel de formato",
      "leftArrow": "Punto de partida",
      "rightArrow": "Punto final",
      "arrowSize": "Tamaño de flecha",
      "lineSize": "Grosor de la línea",
        "lineType": "Tipo de Línea",
        "otherWeight": "Más Grosores de Línea"
    },
    "openanimate": "Activar animación de flujo",
        "lineanimate": "Animación de flujos",
        "deafultopen": "Activado de forma predeterminada",
        "styleset": "Ajustes de estilo",
        "anistyle": "Estilo de flujo",
        "anispeed": "Velocidad de flujo",
        "anidensity": "Densidad de flujo",
        "anicolor": "Color del flujo",
        "anidirection": "Dirección del flujo",
        "aniarrow": "Flechas",
        "anicircle": "Cuentas",
        "anifast": "Rápida",
        "animedium": "Media",
        "anislow": "Lenta",
        "anilarge": "Denso",
        "anifew": "Escaso",
        "aniforward": "Avanzar",
        "anireverse": "Retroceder",
        "showtime": "Cadencia del flujo",
        "openshow": "Mostrar cuando está activado",
        "clickshow": "Mostrar al hacer clic en formas",
        "limit2lines": "Limitado a 2 líneas.",
        "tovip": "Actualizar a Premium para obtener animaciones de flujo ilimitadas.",
    "protectList": {
      "width": "Ancho",
      "height": "Altura",
      "ratio": "Relación de aspecto",
      "horizontal": "Posición X",
      "vertical": "Posición Y",
      "rotate": "Rotación",
      "begin": "Punto de partida",
      "end": "Punto final",
      "group": "Desagrupar",
      "text": "Editar el texto",
      "select": "De selección",
      "delete": "De eliminación",
      "link": "De conexión",
      "format": "Formato",
      "groupFormat": "Del formato de grupo",
      "groupFill": "Del llenado del grupo",
      "theme": "Tema",
      "snapOutline": "Del encaje al esquema",
      "unlock": "Desbloquear todo"
    },
    "searchList": {
      "caseSensitive": "Sensible a mayúsculas y minúsculas",
      "allPage": "Todas las páginas",
      "fullMatch": "Encuentra sólo palabras enteras"
    },
    "acquiesceStyleBox": {
      "lineStyle": "Tipo de línea",
      "lineWidth": "Ancho de la línea",
      "arrowStyle": "Estilo de la flecha",
      "arrowSize": "Tamaño de la flecha",
      "radiusSize": "Tamaño de redondeo",
      "connectorStyle": "Estilo del conector",
      "connectorPoint": "Dirección de salto",
      "connectorPointStyle": "Estilo de salto",
      "defaultPointerStyle": "Estilo de conector predeterminado"
    },
    "optionbox-headColor": "Color superior",
    "optionbox-bodyColor": "Color del carril de natación",
    "optionbox-borderColor": "Color del borde",
    "swimMainTitle": {
      "None": "Nada",
      "Top": "cima",
      "Left": "Izquierda"
    },
    "autoFormatList": {
      "autoFormatting": "Formateo automático",
      "ReplaceClr": "Lote reemplazar color"
    }
  },
  "pt": {
    "Very Small": "Muito Pequeno",
    "Small": "Pequeno",
    "Middle": "Médio",
    "Large": "Grande",
    "Extra Large": "Muito Grande",
    "Jumbo": "Enorme",
    "Colossal": "Colossal",
    "None": "Nenhum",
    "Horizontal": "Horizontal",
    "Vertical": "Vertical",
    "Arc": "Arco",
    "Gap": "Intervalo",
    "Square": "Quadrado",
    "Point2": "Dois Lados",
    "Point3": "Três Lados",
    "mirror": "Inverter",
    "hMirror": "Horizontalmente",
    "vMirror": "Verticalmente",
    "rotate": "Rodar",
    "compose": "Agrupar",
    "uncompose": "Desagrupar",
    "search": "Procurar",
    "replace": "Substituir",
    "lanes": "Faixas",
    "showMainTitle": "Mostrar título principal",
    "rows": "Linhas",
    "columns": "Colunas",
    "orientation": "Alterar Orientação",
    "showOrHideTitle": "Mostrar/Esconder Título",
    "textOrientation": "Alterar Orientação de Texto",
    "dragTitle": "Encontrar & Substituir",
    "layoutTitle": "posição & tamanho",
    "acqTitle": "Estilo de Linha",
    "wallTitle": "Espessura da Parede",
    "wallCheckBox": "Todas as Paredes",
    "noResult": "Sem Resultado",
    "titleColor": "Cor do Título",
    "paddingColor": "Cor do corpo",
    "layout": {
      "width": "Largura",
      "height": "Altura",
      "x": "Posição X",
      "y": "Posição Y"
    },
    "connectorList": {
      "linkLine1": "Conector de Cotovelo",
      "linkLine2": "Conector Curvo",
      "linkLine3": "Conector Reto"
    },
    "tipsList": {
      "toggleLib": "Mostrar Biblioteca de Símbolo",
      "undo": "Desfazer",
      "redo": "Refazer",
      "format": "Formatar Pintor",
      "text": "Adicionar Texto Ctrl+2",
      "textAlign": "Layout, Alinhamento, Relação de Aspecto",
      "layout": "Posição, Largura, Altura, Ângulo",
      "fixRatio": "Bloquear relação de aspecto",
      "layer": "Camada",
      "fillColor": "Preencher Cor",
      "lineColor": "Cor da Linha",
      "compose": "Agrupar",
      "search": "Encontrar",
      "protect": "Bloqueado",
      "unprotect": "Desbloquear",
      "option": "Configurações Excepcionais",
      "acquiesceStyle": "Estilo da Linha",
      "theme": "Estilo Rápido",
      "pageset": "Configurações de Página",
      "connector": "Conector",
      "new-layer1": "Para frente",
    "new-layer2": "Para trás",
    "new-layer3": "Avançar",
    "new-layer4": "Retroceder",
      "align01": "Alinhar à Esquerda",
      "align02": "Alinhar ao Centro",
      "align03": "Alinhar à Direita",
      "align04": "Alinhar em Cima",
      "align05": "Alinhar ao Meio",
      "align06": "Alinhar em Baixo",
      "align07": "Distribuir Horizontalmente",
      "align08": "Distribuir Verticalmente",
      "sameWidth": "Mesma Largura",
      "sameHeight": "Mesma Altura",
      "sameAngle": "Mesmo Ângulo",
      "sameSize": "Mesmo Tamanho",
      "replace": "Substituir",
      "replaceAll": "Substituir Todos",
      "styleBrush": "Pincel de formatação",
      "leftArrow": "Início",
      "rightArrow": "Fim",
      "arrowSize": "Tamanho da seta",
      "lineSize": "Espessura da Linha",
        "lineType": "Tipo de Linha",
        "otherWeight": "Mais espessuras de linha"
    },
    "openanimate": "Habilitar animação de fluxo",
        "lineanimate": "Animação de fluxo",
        "deafultopen": "Habilitado por padrão",
        "styleset": "Configurações de estilo",
        "anistyle": "Estilo de fluxo",
        "anispeed": "Velocidade do fluxo",
        "anidensity": "Densidade do fluxo",
        "anicolor": "Cor do fluxo",
        "anidirection": "Direção do fluxo",
        "aniarrow": "Setas",
        "anicircle": "Esferas",
        "anifast": "Rápido",
        "animedium": "Médio",
        "anislow": "Lento",
        "anilarge": "Denso",
        "anifew": "Esparso",
        "aniforward": "Para a frente",
        "anireverse": "Inversa",
        "showtime": "Tempo do fluxo",
        "openshow": "Exibir quando habilitado",
        "clickshow": "Exibir ao clicar em formas",
        "limit2lines": "Limitado a 2 linhas.",
        "tovip": "Atualize para Premium para animações de fluxo ilimitadas.",
    "protectList": {
      "width": "Largura",
      "height": "Altura",
      "ratio": "Relação de Aspecto",
      "horizontal": "Posição X",
      "vertical": "Posição Y",
      "rotate": "Rotação",
      "begin": "Ponto Inicial",
      "end": "Ponto Final",
      "group": "Desagrupar",
      "text": "Editar Texto",
      "select": "De Seleção",
      "delete": "De Eliminação",
      "link": "De Conexão",
      "format": "Formato",
      "groupFormat": "De Grupo de Formatação",
      "groupFill": "De Grupo de Preenchimento",
      "theme": "Tema",
      "snapOutline": "De Encaixe para Contorno",
      "unlock": "Desbloquear Todos"
    },
    "searchList": {
      "caseSensitive": "Caso Sensível",
      "allPage": "Todas as Páginas",
      "fullMatch": "Encontrar apenas palavras inteiras"
    },
    "acquiesceStyleBox": {
      "lineStyle": "Tipo de Linha",
      "lineWidth": "Largura da Linha",
      "arrowStyle": "Estilo da Seta",
      "arrowSize": "Tamanho da Seta",
      "radiusSize": "Tamanho do Arredondamento",
      "connectorStyle": "Estilo do Conector",
      "connectorPoint": "Direção do Salto",
      "connectorPointStyle": "Estilo do Salto",
      "defaultPointerStyle": "Estilo de Conector Padrão"
    },
    "optionbox-headColor": "Cor Superior",
    "optionbox-bodyColor": "Cor da Raia",
    "optionbox-borderColor": "Cor da borda",
    "swimMainTitle": {
      "None": "Nada",
      "Top": "Alto",
      "Left": "Deixou"
    },
    "autoFormatList": {
      "autoFormatting": "Formatação Automática",
      "ReplaceClr": "Cor de substituição em lote"
    }
  },
  "it": {
    "Very Small": "Molto Piccolo",
    "Small": "Piccolo",
    "Middle": "Medio",
    "Large": "Grande",
    "Extra Large": "Molto Grande",
    "Jumbo": "Enorme",
    "Colossal": "Colossale",
    "None": "Nessuno",
    "Horizontal": "Orizzontale",
    "Vertical": "Verticale",
    "Arc": "Arco",
    "Gap": "Interruzione",
    "Square": "Quadrato",
    "Point2": "Due Lati",
    "Point3": "Tre Lati",
    "mirror": "Capovolgi",
    "hMirror": "Orizzontalmente",
    "vMirror": "Verticalmente",
    "rotate": "Ruota",
    "compose": "Raggruppa",
    "uncompose": "Separa",
    "search": "Cerca",
    "replace": "Sostituisci",
    "lanes": "Corsie",
    "showMainTitle": "Mostra titolo principale",
    "rows": "Righe",
    "columns": "Colonne",
    "orientation": "Modifica Orientamento",
    "showOrHideTitle": "Mostra/Nascondi Titolo",
    "textOrientation": "Modifica Orientamento Testo",
    "dragTitle": "Cerca e Sostituisci",
    "layoutTitle": "posizione & dimensioni",
    "acqTitle": "Stile della linea",
    "wallTitle": "Spessore Parete",
    "wallCheckBox": "Tutte le Pareti",
    "noResult": "Nessun Risultato",
    "titleColor": "Colore del Titolo",
    "paddingColor": "Colore del corpo",
    "layout": {
      "width": "Larghezza",
      "height": "Altezza",
      "x": "Posizione X",
      "y": "Posizione Y"
    },
    "connectorList": {
      "linkLine1": "Connettore ad Angolo",
      "linkLine2": "Connettore Curvo",
      "linkLine3": "Connettore Dritto"
    },
    "tipsList": {
      "toggleLib": "Mostra Libreria dei Simboli",
      "undo": "Annulla",
      "redo": "Ripeti",
      "format": "Applicatore di Formato",
      "text": "Aggiungi Testo Ctrl+2",
      "textAlign": "Layout, Allineamento, Rapporto di Aspetto",
      "layout": "Posizione, Larghezza, Altezza, Angolo",
      "fixRatio": "Blocca Rapporto di Aspetto",
      "layer": "Livello",
      "fillColor": "Colore di Riempimento",
      "lineColor": "Colore Linea",
      "compose": "Raggruppa",
      "search": "Trova",
      "protect": "Bloccato",
      "unprotect": "Sblocca",
      "option": "Impostazioni Speciali",
      "acquiesceStyle": "Stile Linea",
      "theme": "Stile Rapido",
      "pageset": "Impostazioni Pagina",
      "connector": "Connettore",
      "new-layer1": "Porta avanti",
    "new-layer2": "Porta indietro",
    "new-layer3": "Avanti",
    "new-layer4": "Indietro",
      "align01": "Allinea a Sinistra",
      "align02": "Allinea al Centro",
      "align03": "Allinea a Destra",
      "align04": "Allinea in Alto",
      "align05": "Allinea in Mezzo",
      "align06": "Allinea in Basso",
      "align07": "Distribuisci Orizzontalmente",
      "align08": "Distribuisci Verticalmente",
      "sameWidth": "Stessa Larghezza",
      "sameHeight": "Stessa Altezza",
      "sameAngle": "Stesso Angolo",
      "sameSize": "Stessa Dimensione",
      "replace": "Sostituisci",
      "replaceAll": "Sostituisci Tutti",
      "styleBrush": "Pennello stile",
      "leftArrow": "Inizio",
      "rightArrow": "Fine",
      "arrowSize": "Dimensione freccia",
      "lineSize": "Spessore della linea",
        "lineType": "Tipo di linea",
        "otherWeight": "Più Pesi di Linea"
    },
    "openanimate": "Attiva Animazione flusso",
        "lineanimate": "Animazione flusso",
        "deafultopen": "Attivato per impostazione predefinita",
        "styleset": "Impostazioni stile",
        "anistyle": "Stile flusso",
        "anispeed": "Velocità flusso",
        "anidensity": "Densità flusso",
        "anicolor": "Colore flusso",
        "anidirection": "Direzione flusso",
        "aniarrow": "Frecce",
        "anicircle": "Gocce",
        "anifast": "Veloce",
        "animedium": "Media",
        "anislow": "Lenta",
        "anilarge": "Denso",
        "anifew": "Rado",
        "aniforward": "Avanti",
        "anireverse": "Inverti",
        "showtime": "Tempo flusso",
        "openshow": "Visualizza quando attivato",
        "clickshow": "Visualizza quando si fa clic sulle forme",
        "limit2lines": "Limite di 2 righe. ",
        "tovip": "Passa a Premium per animazioni di flusso illimitate.",
    "protectList": {
      "width": "Larghezza",
      "height": "Altezza",
      "ratio": "Rapporto di Aspetto",
      "horizontal": "Posizione X",
      "vertical": "Posizione Y",
      "rotate": "Rotazione",
      "begin": "Punto di Inizio",
      "end": "Punto di Fine",
      "group": "Separa",
      "text": "Modifica Testo",
      "select": "Da Selezione",
      "delete": "Da Eliminazione",
      "link": "Da Connessione",
      "format": "Formato",
      "groupFormat": "Da Formattazione Gruppo",
      "groupFill": "Da Riempimento Gruppo",
      "theme": "Tema",
      "snapOutline": "Da Aggancio al Contorno",
      "unlock": "Sblocca Tutto"
    },
    "searchList": {
      "caseSensitive": "Distinzione Maiuscole/Minuscole",
      "allPage": "Tutte le Pagine",
      "fullMatch": "Solo Parole Intere"
    },
    "acquiesceStyleBox": {
      "lineStyle": "Tipo Linea",
      "lineWidth": "Spessore Linea",
      "arrowStyle": "Stile Freccia",
      "arrowSize": "Dimensione Freccia",
      "radiusSize": "Dimensione Arrotondamento",
      "connectorStyle": "Stile Connettore",
      "connectorPoint": "Direzione Salto",
      "connectorPointStyle": "Stile Salto",
      "defaultPointerStyle": "Stile Connettore Predefinito"
    },
    "optionbox-headColor": "Colore Parte Superiore",
    "optionbox-bodyColor": "Colore Corsia",
    "optionbox-borderColor": "Colore del bordo",
    "swimMainTitle": {
      "None": "Niente",
      "Top": "Superiore",
      "Left": "Sinistra"
    },
    "autoFormatList": {
      "autoFormatting": "Formattazione automatica",
      "ReplaceClr": "Batch Sostituisci colore"
    }
  },
  "tw": {
    "Very Small": "非常小",
    "Small": "小",
    "Middle": "中",
    "Large": "大",
    "Extra Large": "特大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "None": "無",
    "Horizontal": "水平線",
    "Vertical": "垂直線",
    "Arc": "弧線",
    "Gap": "間隙",
    "Square": "正方形",
    "Point2": "兩面",
    "Point3": "三面",
    "mirror": "鏡像",
    "hMirror": "",
    "vMirror": "",
    "rotate": "旋轉",
    "compose": "組合",
    "uncompose": "取消組合",
    "search": "查找",
    "replace": "替換",
    "lanes": "泳道",
    "rows": "行",
    "columns": "列",
    "orientation": "改變方向",
    "showOrHideTitle": "顯示隱藏標題",
    "textOrientation": "改變文本方向",
    "dragTitle": "查找和替換",
    "layoutTitle": "形狀位置大小",
    "acqTitle": "線條樣式",
    "wallTitle": "墻厚度",
    "wallCheckBox": "所有的墻壁",
    "noResult": "沒有找到相應內容",
    "layout": {
      "width": "寬",
      "height": "高",
      "x": "X位置",
      "y": "Y位置"
    },
    "connectorList": {
      "linkLine1": "直角連接線",
      "linkLine2": "曲線連接線",
      "linkLine3": "直線連接線"
    },
    "tipsList": {
      "toggleLib": "顯示符號庫",
      "undo": "復原",
      "redo": "取消復原",
      "format": "格式刷",
      "text": "添加文本   Ctrl+2",
      "textAlign": "佈局、對齊、等寬高",
      "layout": "位置、寬高、角度",
      "fixRatio": "鎖定縱橫比",
      "layer": "層級",
      "fillColor": "填充顏色",
      "lineColor": "線條顏色",
      "compose": "組合",
      "search": "查找",
      "protect": "鎖定",
      "unprotect": "",
      "option": "特殊設置",
      "acquiesceStyle": "線條樣式",
      "theme": "快速樣式",
      "pageset": "頁面設置",
      "connector": "連結線",
      "new-layer1": "移至頂部",
      "new-layer2": "移至底部",
      "new-layer3": "上移一層",
      "new-layer4": "下移一層",
      "align01": "左對齊",
      "align02": "居中對齊",
      "align03": "右對齊",
      "align04": "頂部對齊",
      "align05": "居中對齊",
      "align06": "底部對齊",
      "align07": "水平等間距",
      "align08": "垂直等間距",
      "sameWidth": "等寬",
      "sameHeight": "等高",
      "sameAngle": "等角度",
      "sameSize": "等大小",
      "replace": "替換",
      "replaceAll": "替換全部",
      "styleBrush": "格式刷",
      "leftArrow": "起點",
      "rightArrow": "終點"
    },
    "protectList": {
      "width": "寬度",
      "height": "高度",
      "ratio": "橫縱比",
      "horizontal": "水平位置",
      "vertical": "垂直位置",
      "rotate": "旋轉",
      "begin": "起點",
      "end": "終點",
      "group": "取消組合",
      "text": "編輯文本",
      "select": "選中",
      "delete": "刪除",
      "link": "連接",
      "format": "格式",
      "groupFormat": "組合格式",
      "groupFill": "組合填充",
      "theme": "主題",
      "snapOutline": "連接輪廓",
      "unlock": "解鎖全部"
    },
    "searchList": {
      "caseSensitive": "區分大小寫",
      "allPage": "所有頁面",
      "fullMatch": "全字匹配"
    },
    "acquiesceStyleBox": {
      "lineStyle": "線條樣式",
      "lineWidth": "線條寬度",
      "arrowStyle": "箭頭樣式",
      "arrowSize": "箭頭大小",
      "radiusSize": "圓角大小",
      "connectorStyle": "連接線樣式",
      "connectorPoint": "跳點方案",
      "connectorPointStyle": "跳點樣式",
      "defaultPointerStyle": "設置默認連接線主題"
    },
    "optionbox-headColor": "頂部顏色",
    "optionbox-bodyColor": "泳道顏色",
    "optionbox-borderColor": "邊框顏色",
    "swimMainTitle": {
      "None": "無",
      "Top": "頂部",
      "Left": "左部"
    },
    "autoFormatList": {
      "autoFormatting": "一鍵美化",
      "ReplaceClr": "批量替換顏色"
    }
  },
  "kr": {
    "Very Small": "아주 작다",
    "Small": "소",
    "Middle": "중",
    "Large": "대",
    "Extra Large": "특대",
    "Jumbo": "거대",
    "Colossal": "초대",
    "None": "무",
    "Horizontal": "수평선",
    "Vertical": "수직선",
    "Arc": "호선",
    "Gap": "간극",
    "Square": "정사각형",
    "Point": "포인트",
    "Point2": "양면",
    "Point3": "삼면",
    "mirror": "미러",
    "rotate": "회전",
    "compose": "조합",
    "uncompose": "조합 취소",
    "search": "검색 ",
    "replace": "바꾸기",
    "lanes": "레일",
    "rows": "행",
    "columns": "열",
    "showMainTitle": "홈 제목 보이기",
    "orientation": "방향 바꾸기",
    "showOrHideTitle": "숨겨진 제목 보이기",
    "textOrientation": "텍스트 방향 바꾸기",
    "dragTitle": "검색과 바꾸기",
    "layoutTitle": "모양 위치 크기",
    "acqTitle": "라인 스타일",
    "wallTitle": "벽 두께",
    "wallCheckBox": "모든 벽",
    "noResult": "해당 내용을 찾을 수 없음",
    "layout": {
      "width": "너비",
      "height": "높이",
      "x": "X위치",
      "y": "Y위치"
    },
    "connectorList": {
      "linkLine1": "직각연결선",
      "linkLine2": "곡선연결선",
      "linkLine3": "직선연결선"
    },
    "tipsList": {
      "toggleLib": "심볼 라이브러리 보이기",
      "undo": "취소",
      "redo": "다시 하기 ",
      "format": "형식 브러시",
      "text": "텍스트 추가   Ctrl+2",
      "textAlign": "배치, 정렬, 등 너비 높이",
      "layout": "위치, 너비 높이, 각도",
      "fixRatio": "종횡비 고정하기",
      "layer": "층수",
      "fillColor": "색깔 채우기",
      "lineColor": "라인 색깔",
      "compose": "조합",
      "search": "검색",
      "protect": "고정하기",
      "unprotect": "",
      "option": "특수 설정",
      "acquiesceStyle": "라인 스타일",
      "theme": "빠른 스타일",
      "pageset": "페이지 설정",
      "connector": "연결선",
      "new-layer1": "맨 위로 이동",
      "new-layer2": "아래로 이동",
      "new-layer3": "한 층 위로 이동",
      "new-layer4": "한 층 아래로 이동",
      "align01": "왼쪽 정렬",
      "align02": "가운데 정렬",
      "align03": "오른쪽 정렬",
      "align04": "상단 정렬",
      "align05": "가운데 정렬",
      "align06": "맨 아래 정렬",
      "align07": "수평등간격",
      "align08": "수직등간격",
      "sameWidth": "등 너비",
      "sameHeight": "등 높이",
      "sameAngle": "등 각도",
      "sameSize": "등 크기 ",
      "replace": "바꾸기",
      "replaceAll": "모두 바꾸기",
      "styleBrush": "형식 브러시",
      "leftArrow": "시작점",
      "rightArrow": "종착점"
    },
    "protectList": {
      "width": "너비",
      "height": "높이",
      "ratio": "횡종비",
      "horizontal": "수평 위치",
      "vertical": "수직 위치",
      "rotate": "회전",
      "begin": "시작점",
      "end": "종착점",
      "group": "조합 취소",
      "text": "텍스트 편집",
      "select": "선택",
      "delete": "삭제",
      "link": "연결",
      "format": "형식",
      "groupFormat": "조합 형식",
      "groupFill": "조합 채우기",
      "theme": "주제",
      "snapOutline": "연결 윤곽",
      "unlock": "모든 잠금 해제"
    },
    "searchList": {
      "caseSensitive": "대소문자 구분",
      "allPage": "모든 페이지",
      "fullMatch": "전체 단어만 찾기"
    },
    "acquiesceStyleBox": {
      "lineStyle": "라인 스타일",
      "lineWidth": "라인 너비",
      "arrowStyle": "화살표 스타일",
      "arrowSize": "화살표 크기",
      "radiusSize": "원각 크기",
      "connectorStyle": "연결선 스타일",
      "connectorPoint": "점프 방향",
      "connectorPointStyle": "점프 스타일",
      "electricalCrossStyle": "회로도 교차 스타일",
      "defaultPointerStyle": "기본 연결선 주제 설정"
    },
    "optionbox-headColor": "상단 색깔",
    "optionbox-bodyColor": "레인 색깔",
    "optionbox-borderColor": "테두리 색깔",
    "swimMainTitle": {
      "None": "무",
      "Top": "상단",
      "Left": "왼쪽"
    },
    "autoFormatList": {
      "autoFormatting": "자동 포맷",
      "ReplaceClr": "배치 색깔 바꾸기 "
    }
  }
}
</i18n>
